
document.addEventListener('DOMContentLoaded', () => {
  /******************************************************************
   * 1) CONFIG BÁSICA
   ******************************************************************/
  const topSummary          = document.getElementById('cfg-summary-top');
  const bottomSummary       = document.getElementById('cfg-summary-bottom');
  const topFabricSummary    = document.getElementById('cfg-summary-top-fabric');
  const bottomFabricSummary = document.getElementById('cfg-summary-bottom-fabric');
  const addBtn              = document.getElementById('cfg-add-to-cart');


  // ===== Made to Order =====
  const finalNameEl = document.getElementById('cfg-final-name');
  const modeWrap    = document.getElementById('cfg-purchase-mode');
  const modeMTO     = document.getElementById('cfg-mode-mto');
  const modeTRY     = document.getElementById('cfg-mode-try');
  const priceEl     = document.getElementById('cfg-price');
  const tryPriceEl  = document.getElementById('cfg-try-price');
  const mtoInfoBtn  = document.getElementById('cfg-mto-info');
  const mtoPopover  = document.getElementById('cfg-mto-popover');

  // ===== Try it at home =====
  const tryInfoBtn = document.getElementById('cfg-try-info');
  const tryPopover = document.getElementById('cfg-try-popover');

  // ===== MTO Disclaimer =====
  const mtoDisclaimer = document.getElementById('cfg-mto-disclaimer');
  const mtoConfirm    = document.getElementById('cfg-mto-confirm');

  function showDisclaimer(show){
    if (!mtoDisclaimer) return;
    const wasHidden = mtoDisclaimer.hidden;
    mtoDisclaimer.hidden = !show;

    if (show && wasHidden && mtoConfirm) mtoConfirm.checked = false;
  }

  // ===== 3DLOOK / Medición =====
  const REQUIRE_MEASUREMENT = true;
  const measuredBadge  = document.getElementById('cfg-measured-badge');
  const measuredIdSpan = document.getElementById('cfg-measured-id');
  const measure = { id: null, sessionId: null, reportUrl: null };

  function showMeasureCTA(show) {
    const cont = document.getElementById('saia-widget-container');
    if (!cont) return;
    cont.style.display = show ? '' : 'none';
  }

  function showAddToCart(show) {
    if (!addBtn) return;
    addBtn.style.display = show ? '' : 'none';
  }

  function applyInitialCTAState() {
    const modeVal = document.querySelector('input[name="cfg-mode"]:checked')?.value || 'mto';

    if (modeVal === 'try') {
      showMeasureCTA(false);
      showDisclaimer(false);
      showAddToCart(true);
      return;
    }

    if (!REQUIRE_MEASUREMENT) {
      showMeasureCTA(false);
      showAddToCart(true);
      showDisclaimer(false);
    } else {
      const alreadyMeasured = !!(measure && measure.id);
      showMeasureCTA(!alreadyMeasured);
      showAddToCart(alreadyMeasured);
      showDisclaimer(alreadyMeasured);
    }
  }

  
  const MEAS_KEY = 'CFG_MEASUREMENT_ID';

  function persistMeasurement(id){
    try { localStorage.setItem(MEAS_KEY, String(id)); } catch {}
  }

  function clearPersistedMeasurement(){
    try { localStorage.removeItem(MEAS_KEY); } catch {}
  }

  function restoreMeasurementFromLocalStorage(){
    let mid = null;
    try { mid = localStorage.getItem(MEAS_KEY) || null; } catch {}
    if (mid) { markMeasured(mid, { source: 'cfg-restore' }); return true; }

    try {
      for (const [k, v] of Object.entries(localStorage)) {
        if (!/3dlook|saia|mtm/i.test(k) || !v) continue;
        let val = null; try { val = JSON.parse(v); } catch { val = v; }
        const found =
          val?.measurement_id || val?.measurements_id || val?.person_id || val?.id ||
          (typeof val === 'string' && (val.match(/[0-9a-f-]{8,}/i)?.[0]));
        if (found) {
          markMeasured(found, { source: 'vendor-restore', key: k });
          persistMeasurement(found);
          return true;
        }
      }
    } catch {}
    return false;
  }

  //Descriptions Accordions
  function wireAccordions(){
    document.querySelectorAll('.cfg-acc-h').forEach(btn => {
      const panel = btn.nextElementSibling;
      btn.addEventListener('click', () => {
        const open = btn.getAttribute('aria-expanded') === 'true';
        btn.setAttribute('aria-expanded', String(!open));
        if (panel) panel.hidden = open;
        const ico = btn.querySelector('.cfg-acc-icon');
        if (ico) ico.textContent = open ? '+' : '−';
      });
    });
  }

  // ===== Made to Order =====
  function formatMoney(amount) {
    const v = Number(amount);
    if (!isFinite(v)) return '—';
    const num = v.toLocaleString('en-US', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });
    return `$ ${num}`;
  }

  mtoInfoBtn?.addEventListener('click', () => {
    const open = mtoPopover?.hidden === true;
    if (mtoPopover) mtoPopover.hidden = !open;
  });

  document.addEventListener('click', (e) => {
    if (!e.target.closest('#cfg-mto-info') && !e.target.closest('#cfg-mto-popover')){
      if (mtoPopover) mtoPopover.hidden = true;
    }
  });

  // ===== Try it at home =====
  tryInfoBtn?.addEventListener('click', () => {
    const open = tryPopover?.hidden === true;
    if (tryPopover) tryPopover.hidden = !open;
  });

  document.addEventListener('click', (e) => {
    if (!e.target.closest('#cfg-try-info') && !e.target.closest('#cfg-try-popover')){
      if (tryPopover) tryPopover.hidden = true;
    }
  });

  // UI del select custom
  const topSelectNative    = document.getElementById('cfg-top-fabric');
  const bottomSelectNative = document.getElementById('cfg-bottom-fabric');
  const topSelectUI    = document.getElementById('cfg-top-fabric-ui');
  const bottomSelectUI = document.getElementById('cfg-bottom-fabric-ui');
  const LABEL_SELECT_FABRIC = 'Select a fabric';
  
  // === Fabrics dinámicos (productos con tag "fabric") ===
  const FABRIC_TAG = 'fabric';
  const FABRICS_BY_CODE = {};
  let FABRICS_READY = false;


  async function ensureFabricIndex(){
    if (FABRICS_READY) return;

    const q = `
      query($cursor:String){
        products(first: 100, after:$cursor, query: "tag:${FABRIC_TAG}"){
          pageInfo{ hasNextPage endCursor }
          edges{ node{
            handle title descriptionHtml
            tags
            featuredImage{ url }
            images(first: 1){ edges{ node{ url } } }
            media(first: 10){
              nodes{
                __typename
                ... on MediaImage { image { url } }
                ... on Video {
                  previewImage { url }
                  sources { url mimeType }
                }
                ... on ExternalVideo {
                  host
                  embedUrl
                  previewImage { url }
                }
              }
            }
            variants(first: 100){ edges{ node{ sku } } }
          } }
        }
      }`;

    let cursor = null;

    while (true) {
      const j = await gql(q, { cursor });
      const root  = j?.data?.products;
      const edges = root?.edges || [];

      edges.forEach(e => {
        const n = e.node;

        const imageUrl =
          n?.featuredImage?.url ||
          n?.images?.edges?.[0]?.node?.url || '';
        const descHtml = n?.descriptionHtml || '';

        // leer tags y clasificar
        const tags = (n?.tags || []).map(t => String(t).toLowerCase());
        const kind = tags.includes('exception') ? 'exception' : 'base';

        // Media
        const mediaNodes = n?.media?.nodes || [];
        let videoUrl = '';
        let externalEmbedUrl = '';
        let posterUrl = imageUrl;

        for (const m of mediaNodes) {
          if (m.__typename === 'Video' && Array.isArray(m.sources) && m.sources.length) {
            videoUrl  = (m.sources.find(s => /mp4/i.test(s.mimeType))?.url) || m.sources[0].url || '';
            posterUrl = m?.previewImage?.url || posterUrl;
            break;
          }
          if (m.__typename === 'ExternalVideo' && m.embedUrl) {
            externalEmbedUrl = m.embedUrl;
            posterUrl = m?.previewImage?.url || posterUrl;
          }
        }

        // Mapea TODAS las variantes (cada SKU trae el código de tela)
        (n?.variants?.edges || []).forEach(ve => {
          const code = (ve?.node?.sku || '').trim();
          if (!code) return;
          FABRICS_BY_CODE[code] = {
            code,
            title: n.title || code,
            descriptionHtml: descHtml,
            imageUrl,
            videoUrl,
            externalEmbedUrl,
            posterUrl,
            handle: n.handle,
            kind
          };
        });
      });

      if (!root?.pageInfo?.hasNextPage) break;
      cursor = root.pageInfo.endCursor;
    }

    FABRICS_READY = true;
  }

// NEW REGLA DE NEGOCIO 
  function fabricKind(code){
    return (FABRICS_BY_CODE[code]?.kind) || 'base';
  }

  function swatchCode(btn, role){
    return role === 'top'
      ? (btn?.dataset?.skuTopFabric || btn?.dataset?.fabric || '')
      : (btn?.dataset?.skuBottomFabric || btn?.dataset?.fabric || '');
  }

  function findSwatchByFabricCode(role, code){
    const card = getSelectedCard(role);
    if (!card || !code) return null;
    return [...card.querySelectorAll('.configurator-swatch')]
      .find(s => swatchCode(s, role) === code) || null;
  }

  function findFirstExceptionSwatch(role){
    const card = getSelectedCard(role);
    if (!card) return null;
    return [...card.querySelectorAll('.configurator-swatch')]
      .find(s => fabricKind(swatchCode(s, role)) === 'exception') || null;
  }

  let CFG_SYNCING = false;

  function autoSyncOtherSide(sourceRole, sourceCode){
    
      const target = sourceRole === 'top' ? 'bottom' : 'top';
      filterSideByFinal(target);      
      buildFabricMenu(target);       
      enforceViableSelection(target);
      return true;

  }

// END REGLA DE NEGOCIO

  function uiParts(root){
    return {
      trigger: root?.querySelector('.cfg-fabric-trigger'),
      thumb:   root?.querySelector('.cfg-fabric-trigger .cfg-fabric-thumb'),
      text:    root?.querySelector('.cfg-fabric-trigger .cfg-fabric-text'),
      menu:    root?.querySelector('.cfg-fabric-menu'),
    };
  }

  const $all = (sel, root = document) => Array.from(root.querySelectorAll(sel));

  window.CFG_API = window.CFG_API || { token: '495be658c9a93ba95807d1a826ef63ea', version: '2024-07' };
  (function readApiFromTag(){
    try {
      const el = document.getElementById('cfg-api');
      if (el) Object.assign(window.CFG_API, JSON.parse(el.textContent || '{}'));
    } catch {}
  })();

  const SOURCES = (() => {
    try { return JSON.parse(document.getElementById('cfg-sources')?.textContent || '{}'); }
    catch { return {}; }
  })();

  const FABRIC_OPTION_NAME = SOURCES.fabricOption || 'Fabric';
  const FINAL_COLLECTION_HANDLE = SOURCES.finalCollection || 'shop';

  const CFG_DATA = { tops: [], bottoms: [] };
  const SKU_INDEX = {};
  let CURRENT_VARIANT_GID = null;

  const IMG_CACHE = new Map();


  let LAST_GALLERY_KEY = null;
  const CFG_STRICT_SKU_IMAGES = true;
  const SKU_PLACEHOLDER = SOURCES.skuPlaceholder || '';

  /******************************************************************
  * 2) GQL HELPERS
  ******************************************************************/
  async function gql(query, variables) {
    const { token, version } = window.CFG_API;
    const res = await fetch(`/api/${version}/graphql.json`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Shopify-Storefront-Access-Token': token },
      body: JSON.stringify({ query, variables })
    });
    const json = await res.json().catch(()=> ({}));
    if (json.errors) console.warn('[GQL errors]', json.errors);
    return json;
  }

  async function fetchProductsByCollection(handle) {
    const out = [];
    if (!handle) return out;
    const q = `
      query($h:String!,$cursor:String){
        collectionByHandle(handle:$h){
          products(first: 60, after: $cursor) {
            pageInfo{ hasNextPage endCursor }
            edges{ node{
              handle title featuredImage{ url }
              options{ name values }
                variants(first: 100){
                  edges{ node{
                    id sku image{ url }
                    price{ amount currencyCode }
                    selectedOptions{ name value }
                  } }
                }
            } }
          }
        }
      }`;
    let cursor = null;
    while (true) {
      const j = await gql(q, { h: handle, cursor });
      const root = j?.data?.collectionByHandle?.products;
      const edges = root?.edges || [];
      edges.forEach(e => out.push(e.node));
      if (!root?.pageInfo?.hasNextPage) break;
      cursor = root.pageInfo.endCursor;
    }
    return out;
  }

  async function fetchProductsByTag(tag) {
    const out = [];
    if (!tag) return out;
    const q = `
      query($q:String!,$cursor:String){
        products(first: 60, after:$cursor, query:$q){
          pageInfo{ hasNextPage endCursor }
          edges{ node{
            handle title featuredImage{ url }
            options{ name values }
            variants(first: 100){
              edges{ node{ id sku image{ url } selectedOptions{ name value } } }
            }
          } }
        }
      }`;
    for (const needle of [`tag:${tag}`, `tag:"${tag}"`]) {
      let cursor = null; let gotAny = false;
      while (true) {
        const j = await gql(q, { q: needle, cursor });
        const root = j?.data?.products;
        const edges = root?.edges || [];
        edges.forEach(e => { out.push(e.node); gotAny = true; });
        if (!root?.pageInfo?.hasNextPage) break;
        cursor = root.pageInfo.endCursor;
      }
      if (gotAny) break;
    }
    return out;
  }

  async function fetchVariantBySku(sku) {
    const q = `
      query ($q: String!) {
        productVariants(first: 1, query: $q) {
          edges { node {
            id sku image{ url }
            price { amount currencyCode }
            product { handle title featuredImage { url } }
          } }
        }
      } `;

    for (const needle of ['sku:' + sku, 'sku:"' + sku + '"']) {
      const j = await gql(q, { q: needle });
      const n = j?.data?.productVariants?.edges?.[0]?.node;
      if (n) {
        return {
          id: n.id,
          sku: n.sku,
          imageUrl: n.image?.url || '',
          productHandle: n.product?.handle || '',
          productTitle: n.product?.title || '',
          productImageUrl: n.product?.featuredImage?.url || '',
          priceAmount: Number(n?.price?.amount ?? 0),
          currency: n?.price?.currencyCode || 'USD'
        };

      }
    }
    return null;
  }

  async function fetchProductImages(handle){
    if (!handle) return [];
    if (IMG_CACHE.has(handle)) return IMG_CACHE.get(handle);
    const p = (async () => {
      const query = `
        query($h:String!){
          product(handle:$h){
            images(first: 30){ edges{ node{ url altText } } }
            media(first: 30){ nodes { ... on MediaImage { image { url altText } } } }
          }
        }`;
      const j = await gql(query, { h: handle });
      const imgs1 = (j?.data?.product?.images?.edges || []).map(e => e?.node?.url).filter(Boolean);
      const imgs2 = (j?.data?.product?.media?.nodes || []).map(n => n?.image?.url).filter(Boolean);
      const seen = new Set();
      return [...imgs1, ...imgs2].filter(u => (u && !seen.has(u) && seen.add(u)));
    })();
    IMG_CACHE.set(handle, p);
    return p;
  }

  async function fetchProductDescription(handle){
    if (!handle) return '';
    const q = `query($h:String!){ product(handle:$h){ descriptionHtml } }`;
    const j = await gql(q, { h: handle });
    return j?.data?.product?.descriptionHtml || '';
  }

  /******************************************************************
   * 3) PINTAR CARDS
   ******************************************************************/
  function swatchHTML(v, fabricValue, role, handle) {
    const sku = (v.sku || '').trim();
    let base = '', fab = '';
    if (sku.includes('_')) {
      const parts = sku.split('_');
      base = parts[0] || '';
      fab  = parts[parts.length - 1] || '';
    }
    const baseAttr   = role === 'top'    ? `data-sku-top-base="${base}"`    : `data-sku-bottom-base="${base}"`;
    const fabricAttr = role === 'top'    ? `data-sku-top-fabric="${fab}"`   : `data-sku-bottom-fabric="${fab}"`;
    const fabricTxt  = fabricValue || fab || '';

    const imgHtml = v.image?.url
      ? `<img src="${v.image.url}" alt="${fabricTxt}">`
      : `<span class="configurator-swatch-dot" aria-hidden="true"></span>`;

    return `
      <button class="configurator-swatch"
              title="${fabricTxt}"
              data-product-handle="${handle}"
              data-variant-id="${v.id}"
              data-fabric="${fabricTxt}"
              data-sku="${sku}"
              ${baseAttr} ${fabricAttr}>
        ${imgHtml}
      </button>`;
  }

  function productCardHTML(p, role) {
    const fabricIdx = (p.options || []).findIndex(o => (o?.name || '') === FABRIC_OPTION_NAME);
    const seen = new Set();
    const swatches = [];
    (p.variants?.edges || []).forEach(ve => {
      const v = ve.node;
      let fabricValue = '';
      if (fabricIdx >= 0) {
        const so = v.selectedOptions || [];
        const found = so.find(o => (o?.name || '') === FABRIC_OPTION_NAME);
        fabricValue = found?.value || '';
      }
      const key = fabricValue || v.sku || v.id;
      if (seen.has(key)) return;
      seen.add(key);
      swatches.push(swatchHTML(v, fabricValue, role, p.handle));
    });

    return `
      <article class="configurator-item configurator-item-${role}"
               data-handle="${p.handle}"
               data-title="${p.title.replace(/"/g,'&quot;')}">
        <a href="/products/${p.handle}" class="configurator-thumb" aria-label="${p.title}">
          ${p.featuredImage?.url
            ? `<img loading="lazy" src="${p.featuredImage.url}" alt="${p.title.replace(/"/g,'&quot;')}">`
            : `<div class="configurator-placeholder">No image</div>`}
        </a>
        <div class="configurator-name">${p.title}</div>
        ${swatches.length ? `<div class="configurator-swatches">${swatches.join('')}</div>` : ``}
      </article>`;
  }

  async function loadGroup(gridId, role, source) {
    const grid = document.getElementById(gridId);
    if (!grid) return;
    let products = [];
    if (source?.collection) products = await fetchProductsByCollection(source.collection);
    if (!products.length && source?.tag) products = await fetchProductsByTag(source.tag);

    // Filtros del quiz
    const quiz = readQuizFilters();
    const handles = role === 'top' ? quiz?.tops : quiz?.bottoms;
    if (handles && handles.length) {
      products = products.filter(p => handles.includes(p.handle));
    }

    if (role === 'top') CFG_DATA.tops = products; else CFG_DATA.bottoms = products;
    grid.innerHTML = products.map(p => productCardHTML(p, role)).join('');
  }

  async function loadTopsAndBottoms() {
    await loadGroup('tops-grid', 'top', SOURCES.tops || {});
    await loadGroup('bottoms-grid', 'bottom', SOURCES.bottoms || {});
  }

  /******************************************************************
   * 4) PREVIEW (SKU -> galería)
   ******************************************************************/
  async function buildSkuIndex() {
    const handle = getFinalCollectionHandle();
    const products = await fetchProductsByCollection(handle);
    products.forEach(p => {
      (p.variants?.edges || []).forEach(ve => {
        const v = ve.node;
        const sku = (v?.sku || '').trim();
        if (!sku) return;
        SKU_INDEX[sku] = {
          id: v.id,
          sku,
          imageUrl: v.image?.url || '',
          productHandle: p.handle,
          productTitle: p.title,
          productImageUrl: p.featuredImage?.url || '',
          priceAmount: Number(v?.price?.amount ?? 0),
          currency: v?.price?.currencyCode || 'USD'
        };
      });
    });
  }

  function getFinalCollectionHandle(){
    try {
      const j = JSON.parse(document.getElementById('cfg-collection')?.textContent || '{}');
      if (j && j.handle) return j.handle;
    } catch {}
    return (SOURCES && SOURCES.finalCollection) || 'shop';
  }

  function buildFinalSku() {
    const topSwatch    = document.querySelector('#tops-grid .configurator-swatch.is-active');
    const bottomSwatch = document.querySelector('#bottoms-grid .configurator-swatch.is-active');
    if (!topSwatch || !bottomSwatch) return '';
    const topBase      = topSwatch.dataset.skuTopBase || '';
    const topFabric    = topSwatch.dataset.skuTopFabric || '';
    const bottomBase   = bottomSwatch.dataset.skuBottomBase || '';
    const bottomFabric = bottomSwatch.dataset.skuBottomFabric || '';
    if (!topBase || !bottomBase || !topFabric || !bottomFabric) return '';
    return `${topBase}_${bottomBase}_${topFabric}_${bottomFabric}`;
  }

  function filenameStem(url){
    try{
      const u = new URL(url, location.origin);
      const base = (u.pathname.split('/').pop() || '').split('?')[0];
      return base.replace(/\.[a-z0-9]+$/i,'');
    }catch{
      const base = (String(url||'').split('?')[0].split('/').pop()||'');
      return base.replace(/\.[a-z0-9]+$/i,'');
    }
  }

  function filterSkuImages(urls, finalSku){
    if (!finalSku) return [];
    const esc = finalSku.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    const re = new RegExp(`^${esc}-(\\d+)$`, 'i'); 

    const matches = [];
    for (const u of urls){
      const stem = filenameStem(u);
      const m = re.exec(stem);
      if (m){
        matches.push({ url: u, n: parseInt(m[1],10) || 0 });
      }
    }
    matches.sort((a,b)=> a.n - b.n || a.url.localeCompare(b.url));
    return matches.map(m=>m.url);
  }

  function ensurePreviewShell() {
    const preview = document.querySelector('.configurator-preview');
    let main = preview.querySelector('.configurator-preview-main');
    if (!main) {
      main = document.createElement('div');
      main.className = 'configurator-preview-main';
      preview.appendChild(main);
    }

    let prev = preview.querySelector('.cfg-prev');
    let next = preview.querySelector('.cfg-next');
    if (!prev) {
      prev = document.createElement('button');
      prev.type = 'button';
      prev.className = 'cfg-prev';
      prev.setAttribute('aria-label', 'Previous image');
      preview.appendChild(prev);
    }
    if (!next) {
      next = document.createElement('button');
      next.type = 'button';
      next.className = 'cfg-next';
      next.setAttribute('aria-label', 'Next image');
      preview.appendChild(next);
    }

    const thumbsWrap  = document.querySelector('.cfg-thumbs');
    const thumbsTrack = document.getElementById('cfg-thumbs');

    return { main, thumbsWrap, thumbsTrack, prev, next };
  }


  async function renderProductGallery(handle, preferredUrl, finalSku){
    const { main, thumbsWrap, thumbsTrack, prev, next } = ensurePreviewShell();
    if (!thumbsWrap || !thumbsTrack || !main) return;


    const urls = await fetchProductImages(handle);
    const skuList = filterSkuImages(urls, finalSku);

    let list = [];
    let usingPlaceholder = false;

    if (skuList.length) {
      list = skuList;
    } else if (typeof CFG_STRICT_SKU_IMAGES !== 'undefined' && CFG_STRICT_SKU_IMAGES && typeof SKU_PLACEHOLDER !== 'undefined' && SKU_PLACEHOLDER) {
      list = [SKU_PLACEHOLDER];
      usingPlaceholder = true;
    } else {
      list = [...new Set([preferredUrl, ...urls].filter(Boolean))];
    }

    const isMobile = window.matchMedia('(max-width: 900px)').matches;
    const mobileEligible = isMobile && !usingPlaceholder && list.length > 0;

    if (mobileEligible) {
      const key = `${handle}::${skuList.length ? finalSku : 'ALL'}`;

      MOBILE_GALLERY.mount(main, key, list);

      if (thumbsWrap) thumbsWrap.hidden = true;

      LAST_GALLERY_KEY = key;

      return;
    }

    try { MOBILE_GALLERY.cleanup(); } catch {}

    thumbsTrack.innerHTML = usingPlaceholder
      ? ''
      : list.map(u => `
          <button class="cfg-thumb" type="button" data-src="${u}">
            <img src="${u}" alt="">
          </button>
        `).join('');

    thumbsWrap.hidden = usingPlaceholder || list.length <= 1;

    const setMain = (url) => {
      let img = main.querySelector('img.configurator-preview-img');
      if (!img) {
        img = document.createElement('img');
        img.className = 'configurator-preview-img';
        img.loading = 'lazy';
        main.innerHTML = '';
        main.appendChild(img);
      }
      if (img.src !== url) {
        img.style.opacity = '0';
        img.onload = () => { img.style.opacity = '1'; img.onload = null; };
        img.src = url;
      }
    };

    let currentIndex = 0;
    const clamp = (i) => Math.max(0, Math.min(list.length - 1, i));

    const updatePreviewArrows = () => {
      const atStart = currentIndex <= 0;
      const atEnd   = currentIndex >= list.length - 1;
      const visible = list.length > 1 && !usingPlaceholder;
      prev.style.visibility = visible ? 'visible' : 'hidden';
      next.style.visibility = visible ? 'visible' : 'hidden';
      prev.disabled = atStart;
      next.disabled = atEnd;
    };

    const setActiveByIndex = (i) => {
      currentIndex = clamp(i);
      const url = list[currentIndex] || '';
      if (url) setMain(url);
      thumbsTrack.querySelectorAll('.cfg-thumb').forEach((b, idx) => {
        b.classList.toggle('is-active', idx === currentIndex);
      });
      updatePreviewArrows();
    };

    if (!usingPlaceholder) {
      thumbsTrack.querySelectorAll('.cfg-thumb').forEach((btn, idx) => {
        btn.addEventListener('click', () => setActiveByIndex(idx));
      });
    }

    const first = list[0] || '';
    if (first) {
      setMain(first);
      setActiveByIndex(0);
    } else {
      main.innerHTML = `<div style="color:#6b6f76;font:600 14px system-ui">No images</div>`;
    }

    prev.onclick = () => setActiveByIndex(currentIndex - 1);
    next.onclick = () => setActiveByIndex(currentIndex + 1);

    main.tabIndex = 0;
    main.onkeydown = (e) => {
      if (e.key === 'ArrowLeft')  { e.preventDefault(); setActiveByIndex(currentIndex - 1); }
      if (e.key === 'ArrowRight') { e.preventDefault(); setActiveByIndex(currentIndex + 1); }
    };

    initThumbsControls?.();

    const key = `${handle}::${skuList.length ? finalSku : (usingPlaceholder ? 'PLACEHOLDER' : 'ALL')}`;
    LAST_GALLERY_KEY = key;
  }


  //WHISHLIST
  
  async function fetchProductIdByHandle(handle){
    if (!handle) return null;
    const q = `query($h:String!){ product(handle:$h){ id } }`;
    const j = await gql(q, { h: handle });
    const gid = j?.data?.product?.id || '';                  // ej: gid://shopify/Product/7096437407942
    const empi = Number(String(gid).split('/').pop() || 0);   // -> 7096437407942
    return empi || null;
  }

  function onSwymReady(cb, tries = 60){
    if (window.Swym || window._swat) { try{cb();}catch{} return; }
    if (tries <= 0) return;
    setTimeout(()=>onSwymReady(cb, tries-1), 200);
  }

  function fetchSwymLists(){
    return new Promise((resolve, reject)=>{
      onSwymReady(()=>{
        try{
          window._swat.fetchLists({
            callbackFn: (lists)=>resolve(lists||[]),
            errorFn: (err)=>reject(err)
          });
        }catch(e){ reject(e); }
      });
    });
  }

  function isInWishlist(lists, epi, empi){
    let lid = lists && lists[0]?.lid ? lists[0].lid : null;
    let found = false, item=null;
    for (const list of (lists||[])){
      lid = lid || list.lid;
      for (const it of (list.listcontents||[])){
        if (String(it.epi)==String(epi) && String(it.empi)==String(empi)){
          found = true; item = it; lid = list.lid; break;
        }
      }
      if (found) break;
    }
    return { found, lid, item };
  }

  async function ensureDefaultList(){
    const lists = await fetchSwymLists();
    if (lists.length) return lists;
    return new Promise((resolve)=>{
      onSwymReady(()=>{
        try{
          window._swat.createList({ lname: "Saved Items" }, ()=>{
            fetchSwymLists().then(resolve).catch(()=>resolve([]));
          }, ()=>resolve([]));
        }catch{ resolve([]); }
      });
    });
  }

  async function syncWishlistState(){
    const btn = document.getElementById('cfg-wishlist');
    if (!btn) return;
    const epi  = btn.dataset.epi || btn.dataset.variantId;
    const empi = btn.dataset.empi;
    if (!epi || !empi) return;

    const lists = await fetchSwymLists().catch(()=>[]);
    const { found, lid } = isInWishlist(lists, epi, empi);
    btn.dataset.lid = lid || '';

    btn.classList.toggle('swym-added', !!found);
    btn.setAttribute('aria-pressed', found ? 'true' : 'false');
  }


  async function setWishlistDataAttrsFromNode(node, finalSku){
    const btn = document.getElementById('cfg-wishlist');
    if (!btn || !node) return;

    const variantIdNum = String(node.id||'').split('/').pop();
    const handle   = node.productHandle || '';
    const url      = handle ? `${location.origin}/products/${handle}` : location.href;
    const title    = node.productTitle || 'Custom Dress';
    const image    = node.imageUrl || node.productImageUrl || '';
    const price    = Number(node.priceAmount || 0);
    const currency = node.currency || 'USD';

    // Nuevo: obtener empi (product id numérico)
    const empi = await fetchProductIdByHandle(handle);

    btn.setAttribute('data-variant-id', variantIdNum);
    btn.setAttribute('data-epi', variantIdNum);
    btn.setAttribute('data-product-url', url);
    btn.setAttribute('data-product-title', title);
    image ? btn.setAttribute('data-image-url', image) : btn.removeAttribute('data-image-url');
    price>0 ? btn.setAttribute('data-price', String(price)) : btn.removeAttribute('data-price');
    btn.setAttribute('data-currency', currency);
    btn.setAttribute('data-sku', finalSku || '');
    if (empi) btn.setAttribute('data-empi', String(empi));

    const wl = document.getElementById('cfg-wishlist');
    if (wl) { wl.classList.remove('swym-added'); wl.setAttribute('aria-pressed','false'); }

    await syncWishlistState();
  }
  //endWishlist

  async function updatePreview() {
    const { main, thumbsWrap } = ensurePreviewShell();
    const finalSku = buildFinalSku();
    if (!finalSku || !main) { if (addBtn) addBtn.disabled = true; return; }
    if (!main.querySelector('img.configurator-preview-img')) {
      main.innerHTML = `<div style="color:#6b6f76;font:600 14px system-ui">Loading…</div>`;
    }
    let node = SKU_INDEX[finalSku];
    if (!node) node = await fetchVariantBySku(finalSku);
    if (!node) {
      CURRENT_VARIANT_GID = null;
      if (addBtn) addBtn.disabled = true;
      main.innerHTML = `<div style="color:#6b6f76;font:600 14px system-ui">No match for SKU: <code>${finalSku}</code></div>`;
      if (thumbsWrap) thumbsWrap.hidden = true;
      return;
    }
    CURRENT_VARIANT_GID = node.id;

    window.CURRENT_VARIANT_GID = CURRENT_VARIANT_GID;

    window.CFG_FINAL_HANDLE = node.productHandle || null;
    window.CFG_FINAL_TITLE  = node.productTitle  || '';
    window.CFG_FINAL_IMAGE  = node.imageUrl || node.productImageUrl || '';

    if (addBtn) addBtn.disabled = false;

    ///MADE TO ORDER
    if (finalNameEl) {
      const nameEl = finalNameEl.querySelector('.cfg-dress-name');
      const skuEl = finalNameEl.querySelector('.cfg-dress-sku');
      if (nameEl) nameEl.textContent = node.productTitle || '—';
      if (skuEl) {
        skuEl.textContent = node.sku ? `SKU: ${node.sku}` : '—';
        skuEl.style.display = node.sku ? 'inline' : 'none';
      }
    }
    if (priceEl) priceEl.textContent = formatMoney(node.priceAmount);
    if (modeWrap) modeWrap.hidden = false;

  
    await renderProductGallery(
      node.productHandle,
      node.imageUrl || node.productImageUrl || '',
      finalSku
    );

    try {
      const descEl = document.getElementById('cfg-description-content');
      if (descEl) {
        const html = await fetchProductDescription(node.productHandle);
        descEl.innerHTML = html || '—';
      }
    } catch(e){ /* noop */ }

    try { window.__CFG_TRY__?.setCurrentFinalHandle(node.productHandle); } catch {}

    //Funciona para el whishlist 
    await setWishlistDataAttrsFromNode(node, finalSku);

  }

  /******************************************************************
   * 5) INTERACCIONES (cards + telas)
   ******************************************************************/

  function setFabricSummary(role, name){
    const val = name && String(name).trim() ? name : '—';
    if (role === 'top') {
      topFabricSummary && (topFabricSummary.textContent = val);
    } else {
      bottomFabricSummary && (bottomFabricSummary.textContent = val);
    }
  }

  function wireInteractions() {
    $all('.configurator-item').forEach(card => {
      const selectCard = () => {
        const isTop   = card.classList.contains('configurator-item-top');
        const role    = isTop ? 'top' : 'bottom';
        const groupSel = isTop ? '#tops-grid' : '#bottoms-grid';

        const prevFabric =
          isTop ? (topFabricSummary?.textContent || '') : (bottomFabricSummary?.textContent || '');

        $all(`${groupSel} .configurator-item`).forEach(c => c.classList.remove('is-selected'));
        $all(`${groupSel} .configurator-swatch.is-active`).forEach(s => s.classList.remove('is-active'));
        card.classList.add('is-selected');

        const title = card.dataset.title || '—';
        if (isTop) topSummary.textContent = title; else bottomSummary.textContent = title;
        if (isTop) topFabricSummary.textContent = '—'; else bottomFabricSummary.textContent = '—';

        const picked = selectFirstViableForRole(role, prevFabric);

        if (!picked) {
          if (isTop) buildFabricMenu('top'); else buildFabricMenu('bottom');
          updatePreview();
        }

        checkReady();
      };

      card.addEventListener('click', (e) => {
        if (e.target.closest('.configurator-thumb')) e.preventDefault();
        selectCard();
      });
    });

    $all('.configurator-swatch').forEach(btn => {
      const activate = () => {
        const card   = btn.closest('.configurator-item');
        const isTop  = card.classList.contains('configurator-item-top');
        const role   = isTop ? 'top' : 'bottom';
        const group  = isTop ? '#tops-grid' : '#bottoms-grid';

        if (!card.classList.contains('is-selected')) {
          $all(`${group} .configurator-item`).forEach(c => c.classList.remove('is-selected'));
          card.classList.add('is-selected');
          const title = card.dataset.title || '—';
          if (isTop) topSummary.textContent = title; else bottomSummary.textContent = title;
        }
        $all('.configurator-swatch', card).forEach(s => s.classList.remove('is-active'));
        btn.classList.add('is-active');

        const fabricName =
          btn.dataset.fabric ||
          (isTop ? btn.dataset.skuTopFabric : btn.dataset.skuBottomFabric) ||
          '';
        setFabricSummary(role, fabricName);
        checkReady(); 


        const code = role === 'top'
          ? (btn.dataset.skuTopFabric || btn.dataset.fabric || '')
          : (btn.dataset.skuBottomFabric || btn.dataset.fabric || '');
        if (!isFabricViable(role, code)) {
          btn.classList.add('is-unavailable');
          return;
        }
        if (!CFG_SYNCING) autoSyncOtherSide(role, code);


        updateCompatibility();
        updatePreview();
        if (isTop) buildFabricMenu('top'); else buildFabricMenu('bottom');
      };

      btn.addEventListener('click', (e) => { e.stopPropagation(); activate(); });
    });

  }

  function invalidateMeasurement() {
    measure.id = null;
    measure.sessionId = null;
    measure.reportUrl = null;
    if (measuredBadge) measuredBadge.hidden = true;
    if (measuredIdSpan) measuredIdSpan.textContent = '—';
    showDisclaimer(false);
    if (mtoConfirm) mtoConfirm.checked = false;
    checkReady();

    if (REQUIRE_MEASUREMENT) {
      showMeasureCTA(true);
      showAddToCart(false);
    }
  }

  function checkReady() {
    const selectionsReady =
      (document.getElementById('cfg-summary-top')?.textContent !== '—') &&
      (document.getElementById('cfg-summary-bottom')?.textContent !== '—') &&
      (document.getElementById('cfg-summary-top-fabric')?.textContent !== '—') &&
      (document.getElementById('cfg-summary-bottom-fabric')?.textContent !== '—');

    const addBtn = document.getElementById('cfg-add-to-cart');
    if (!addBtn) return;

    const modeVal = document.querySelector('input[name="cfg-mode"]:checked')?.value || 'mto';

    if (modeVal === 'try') {

      if (window.__CFG_TRY__?.getSizeStatus?.() === 'unavailable') {
        addBtn.disabled = true;
        addBtn.textContent = 'SIZE UNAVAILABLE';
        return;
      }

      const trySelected = window.__CFG_TRY__?.getSelectedTryVariant?.();
      const ready = selectionsReady && !!trySelected;

      addBtn.disabled = !ready;
      addBtn.textContent = trySelected ? 'ADD TO CART' : 'SELECT A SIZE';
      return;
    }


    const measureId = document.getElementById('cfg-measured-id')?.textContent || null;
    const measurementReady = !REQUIRE_MEASUREMENT || !!(measureId && measureId !== '—');
    const needsDisclaimer = measurementReady;
    const disclaimerOk = !needsDisclaimer || (document.getElementById('cfg-mto-confirm')?.checked === true);

    addBtn.disabled = !(selectionsReady && measurementReady && disclaimerOk);
  }

  mtoConfirm?.addEventListener('change', checkReady);

  function updatePurchaseModeState(){
    const modeVal = document.querySelector('input[name="cfg-mode"]:checked')?.value || 'mto';
    if (modeVal === 'mto' && measure.id) {
      showDisclaimer(true);
    } else {
      showDisclaimer(false);
      if (mtoConfirm) mtoConfirm.checked = false;
    }
    checkReady();
  }

  modeMTO?.addEventListener('change', updatePurchaseModeState);
  modeTRY?.addEventListener('change', updatePurchaseModeState);

  /******************************************************************
   * 6) SELECT CUSTOM (fabric)
   ******************************************************************/
  function getSelectedCard(role){
    const gridSel = role === 'top' ? '#tops-grid' : '#bottoms-grid';
    return document.querySelector(`${gridSel} .configurator-item.is-selected`) || null;
  }
  
  function getFabricImageFromCard(card, role, fabricName){
    if (!card || !fabricName) return '';
    const sw = [...card.querySelectorAll('.configurator-swatch')].find(s => {
      const f = s.dataset.fabric || (role === 'top' ? s.dataset.skuTopFabric : s.dataset.skuBottomFabric) || '';
      return f === fabricName;
    });
    const img = sw?.querySelector('img');
    return img?.getAttribute('src') || '';
  }

  function collectFabricsFromCard(card, role){
    if (!card) return [];
    const out = []; const seen = new Set();
    card.querySelectorAll('.configurator-swatch').forEach(sw => {
      const fabric = sw.dataset.fabric || (role === 'top' ? sw.dataset.skuTopFabric : sw.dataset.skuBottomFabric) || '';
      if (!fabric || seen.has(fabric)) return;
      seen.add(fabric);
      out.push({ fabric, img: sw.querySelector('img')?.getAttribute('src') || '' });
    });
    return out;
  }

  function findFabricCode(role, fabricKey){
    const card = getSelectedCard(role);
    if (!card) return '';
    const sw = [...card.querySelectorAll('.configurator-swatch')].find(s => {
      const name = s.dataset.fabric
        || (role === 'top' ? s.dataset.skuTopFabric : s.dataset.skuBottomFabric)
        || '';
      const code = role === 'top' ? s.dataset.skuTopFabric : s.dataset.skuBottomFabric;
      return name === fabricKey || code === fabricKey;
    });
    return sw ? (role === 'top' ? (sw.dataset.skuTopFabric || '') : (sw.dataset.skuBottomFabric || '')) : '';
  }

  

  function buildFabricMenu(role){
    const root   = role === 'top' ? topSelectUI : bottomSelectUI;
    const native = role === 'top' ? topSelectNative : bottomSelectNative;
    const { trigger, thumb, text, menu } = uiParts(root);
    const card = getSelectedCard(role);
    if (!root || !menu || !trigger) return;

    const fabrics = collectFabricsFromCard(card, role);
    menu.innerHTML = '';

    // Habilita el select visualmente
    root.classList.remove('is-disabled');
    trigger.removeAttribute('aria-disabled');
    trigger.disabled = false;

    // Construye TODAS las telas, marcando como "no viable" las que no combinan con nada
    fabrics.forEach(({ fabric, img }) => {
      const code = findFabricCode(role, fabric) || fabric;
      const viable = isFabricViable(role, code);

      const li = document.createElement('li');
      li.className = 'cfg-fabric-option' + (viable ? '' : ' is-unavailable');
      li.setAttribute('role','option');
      li.dataset.fabric = fabric;
      li.setAttribute('aria-disabled', viable ? 'false' : 'true');
      li.innerHTML = `
        <span class="thumb" style="${img ? `background-image:url('${img}')` : ''}">
          <button type="button" class="info-dot" aria-label="Fabric details for ${fabric}"></button>
        </span>
        <span class="name">${fabric}</span>
      `;

      // Click: si no es viable, ignorar selección
      li.addEventListener('click', () => {
        if (li.getAttribute('aria-disabled') === 'true') return;
        selectFabric(role, fabric);
      });

      // Botón (i) siempre funciona
      li.querySelector('.info-dot')?.addEventListener('click', (ev) => {
        ev.stopPropagation();
        openFabricInfo(role, fabric);
        toggleMenu(role === 'top' ? topSelectUI : bottomSelectUI, false);
      });

      if (IS_DESKTOP_HOVER.matches) {
        li.addEventListener('mouseenter', () => scheduleOpenFabricInfo(role, fabric));
        li.addEventListener('mouseleave', () => scheduleCloseFabricInfo());
        li.addEventListener('focusin',  () => scheduleOpenFabricInfo(role, fabric));
        li.addEventListener('focusout', () => scheduleCloseFabricInfo());
      }

      // Hover (desktop) SIEMPRE, aunque esté aria-disabled
      // if (IS_DESKTOP_HOVER.matches) {
      //   const thumbEl = li.querySelector('.thumb');
      //   const nameEl  = li.querySelector('.name');

      //   const addHover = (el) => {
      //     if (!el) return;
      //     el.addEventListener('mouseenter', () => scheduleOpenFabricInfo(role, fabric));
      //     el.addEventListener('mouseleave', () => scheduleCloseFabricInfo());
      //     el.addEventListener('focusin',  () => scheduleOpenFabricInfo(role, fabric));
      //     el.addEventListener('focusout', () => scheduleCloseFabricInfo());
      //   };

      //   // Aplica a li y a subelementos para ser robustos
      //   addHover(li);
      //   addHover(thumbEl);
      //   addHover(nameEl);
      // }

      menu.appendChild(li);
    });

    // Refleja la selección actual
    const activeSw = card?.querySelector('.configurator-swatch.is-active');
    const currentFabric = activeSw?.dataset.fabric || '';
    [...menu.children].forEach(li => li.setAttribute('aria-selected','false'));
    const selectedLi = [...menu.children].find(li => li.dataset.fabric === currentFabric && li.getAttribute('aria-disabled')==='false');
    if (selectedLi) selectedLi.setAttribute('aria-selected','true');

    const img = getFabricImageFromCard(card, role, currentFabric);
    if (thumb) thumb.style.backgroundImage = img ? `url("${img}")` : 'none';
    if (text)  text.textContent = currentFabric || LABEL_SELECT_FABRIC;
    if (native){
      native.value = currentFabric || '';
      native.disabled = !currentFabric;
    }

    // Aplica el estado a los swatches y sincroniza menú con swatches disabled (por final-candidate)
    applyViabilityToSwatches(role);
    syncMenuDisabledFromCard(role);

    // Si la activa quedó inválida, corrige
    enforceViableSelection(role);
  }


  function selectFabric(role, fabricName){

    const candCode = findFabricCode(role, fabricName) || fabricName;
    if (!isFabricViable(role, candCode)) return;

    const root = role === 'top' ? topSelectUI : bottomSelectUI;
    const native = role === 'top' ? topSelectNative : bottomSelectNative;
    const { menu, thumb, text } = uiParts(root);

    const card = getSelectedCard(role);

    const swDisabled = card && [...card.querySelectorAll('.configurator-swatch')]
    .find(s => (s.dataset.fabric || (role === 'top' ? s.dataset.skuTopFabric : s.dataset.skuBottomFabric)) === fabricName)?.disabled;
    if (swDisabled) return;

    const sw = card && [...card.querySelectorAll('.configurator-swatch')]
      .find(s => (s.dataset.fabric || (role === 'top' ? s.dataset.skuTopFabric : s.dataset.skuBottomFabric)) === fabricName);
    if (sw) sw.click();

    setFabricSummary(role, fabricName);
    checkReady();


    [...menu.children].forEach(li => li.setAttribute('aria-selected','false'));
    const li = [...menu.children].find(li => li.dataset.fabric === fabricName);
    li?.setAttribute('aria-selected','true');

    const imgUrl = getFabricImageFromCard(card, role, fabricName);
    if (thumb) thumb.style.backgroundImage = imgUrl ? `url("${imgUrl}")` : 'none';
    if (text)  text.textContent = fabricName;
    if (native){ native.value = fabricName; native.disabled = false; }

    toggleMenu(root, false);

     updateCompatibility();

     closeFabricInfo();

    //NUEVA REGLA DE NEGOCIO
    const code = findFabricCode(role, fabricName);
    // autoSyncOtherSide(role, code);
    if (!CFG_SYNCING) autoSyncOtherSide(role, code);

  }

  function toggleMenu(root, force){
    const { trigger, menu } = uiParts(root);
    const open = typeof force === 'boolean' ? force : menu.hidden;
    menu.hidden = !open;
    trigger.setAttribute('aria-expanded', String(open));
    if (open) {
      menu.focus();
    } else {
      closeFabricInfo();
    }
  }

  function closeAllFabricMenus(){
    [topSelectUI, bottomSelectUI].forEach(root => {
      if (!root) return;
      const { trigger, menu } = uiParts(root);
      if (menu && !menu.hidden){
        menu.hidden = true;
        trigger?.setAttribute('aria-expanded','false');
      }
    });
  }

  document.addEventListener('click', (e) => {
    const isInside = e.target.closest('.cfg-fabric-select');
    if (!isInside) closeAllFabricMenus();
  });
  [topSelectUI, bottomSelectUI].forEach(root => {
    if (!root) return;
    const { trigger, menu } = uiParts(root);
    trigger?.addEventListener('click', () => toggleMenu(root));
    menu?.addEventListener('keydown', (e) => {
      const items = [...menu.querySelectorAll('.cfg-fabric-option')];
      const idx = items.findIndex(li => li.getAttribute('aria-selected') === 'true');
      if (e.key === 'ArrowDown'){ e.preventDefault(); (items[Math.min(idx+1, items.length-1)] || items[0]).focus?.(); }
      if (e.key === 'ArrowUp'){   e.preventDefault(); (items[Math.max(idx-1, 0)] || items[0]).focus?.(); }
      if (e.key === 'Escape'){    e.preventDefault(); toggleMenu(root, false); uiParts(root).trigger.focus(); }
      if (e.key === 'Enter' || e.key === ' '){
        e.preventDefault();
        const current = items[idx >= 0 ? idx : 0];
        current?.click();
      }
    });
  });


  // ===== refs del panel
  const fabricPanel = document.getElementById('cfg-fabric-info');
  const fiMedia     = document.getElementById('cfg-fi-media');
  const fiTitle     = document.getElementById('cfg-fi-title');
  const fiDesc      = document.getElementById('cfg-fi-desc');
  const fiClose     = fabricPanel?.querySelector('.cfg-fi-close');
 
  async function openFabricInfo(role, fabricKey){
    const summary = document.querySelector('.configurator-summary');
    const card = getSelectedCard(role);

    const displayName = fabricKey || card?.querySelector('.configurator-swatch.is-active')?.dataset.fabric || 'Fabric';
    const imgUrlLocal = getFabricImageFromCard(card, role, displayName);

    // 2) Código de tela (SKU)
    let code = findFabricCode(role, fabricKey);
    if (!code && card) {
      const activeSw = card.querySelector('.configurator-swatch.is-active');
      code = role === 'top' ? (activeSw?.dataset.skuTopFabric || '') : (activeSw?.dataset.skuBottomFabric || '');
    }

    await ensureFabricIndex();
    const info = code ? FABRICS_BY_CODE[code] : null;

    fiTitle.textContent = info?.title || displayName || 'Fabric';
    fiDesc.innerHTML    = info?.descriptionHtml || info?.description || '—';

    const fallbackImg = info?.posterUrl || info?.imageUrl || imgUrlLocal || '';

    if (fiMedia) {
      try { fiMedia.querySelector('video')?.pause(); } catch {}
      fiMedia.innerHTML = '';

      if (info?.videoUrl) {
        fiMedia.innerHTML = `
          <video controls autoplay muted loop playsinline preload="metadata" ${fallbackImg ? `poster="${fallbackImg}"` : ''}>
            <source src="${info.videoUrl}" type="video/mp4">
          </video>`;
      } else if (info?.externalEmbedUrl) {
        const url = info.externalEmbedUrl.includes('?')
          ? info.externalEmbedUrl + '&autoplay=1&mute=1&playsinline=1&loop=1'
          : info.externalEmbedUrl + '?autoplay=1&mute=1&playsinline=1&loop=1';
        fiMedia.innerHTML = `
          <iframe
            src="${url}"
            allow="autoplay; encrypted-media; picture-in-picture"
            loading="lazy"
            referrerpolicy="no-referrer"
            allowfullscreen
          ></iframe>`;
      } else {
        fiMedia.innerHTML = `<img alt="${fiTitle.textContent}" ${fallbackImg ? `src="${fallbackImg}"` : ''}>`;
      }
    }

    fabricPanel.hidden = false;
    summary?.classList.add('is-showing-fabric');

    if (!info) console.warn('[Fabric info] No encontrado para código:', code, 'key:', fabricKey);
  }

  function closeFabricInfo(){
    try { fiMedia?.querySelector('video')?.pause(); } catch {}
    fabricPanel.hidden = true;
    document.querySelector('.configurator-summary')?.classList.remove('is-showing-fabric');
  }

  // Detectar dispositivos con hover/fine pointer (desktop)
  const IS_DESKTOP_HOVER = window.matchMedia('(hover: hover) and (pointer: fine)');

  let FI_HOVER_OPEN_T = null;
  let FI_HOVER_CLOSE_T = null;

  function scheduleOpenFabricInfo(role, fabric, delay = 120){
    clearTimeout(FI_HOVER_OPEN_T);
    clearTimeout(FI_HOVER_CLOSE_T);
    FI_HOVER_OPEN_T = setTimeout(() => openFabricInfo(role, fabric), delay);
  }
  function scheduleCloseFabricInfo(delay = 180){
    clearTimeout(FI_HOVER_OPEN_T);
    clearTimeout(FI_HOVER_CLOSE_T);
    FI_HOVER_CLOSE_T = setTimeout(() => closeFabricInfo(), delay);
  }

  fiClose?.addEventListener('click', closeFabricInfo);
  document.addEventListener('keydown', (e)=>{ if(e.key==='Escape') closeFabricInfo(); });


  // === Compatibilidad de telas (usar SKU_INDEX ya construido) ===
    function skuExists(sku){ return !!SKU_INDEX[sku]; }

    function getActiveSwatch(role){
      const gridSel = role === 'top' ? '#tops-grid' : '#bottoms-grid';
      return document.querySelector(`${gridSel} .configurator-swatch.is-active`) || null;
    }

    // === PARCHE (ocultar telas que NO forman SKU final) ===

    function sku4(topBase, botBase, topFab, botFab){
      if (!topBase || !botBase || !topFab || !botFab) return '';
      return `${topBase}_${botBase}_${topFab}_${botFab}`;
    }

    function listFabricCodes(role){
      const card = getSelectedCard(role);
      if (!card) return [];
      return [...card.querySelectorAll('.configurator-swatch')]
        .map(s => role === 'top'
          ? (s.dataset.skuTopFabric || s.dataset.fabric || '')
          : (s.dataset.skuBottomFabric || s.dataset.fabric || ''))
        .filter(Boolean);
    }

    function getBaseCodes(){
      const topSw = getActiveSwatch('top');
      const botSw = getActiveSwatch('bottom');
      return {
        topBase: topSw?.dataset?.skuTopBase || '',
        botBase: botSw?.dataset?.skuBottomBase || ''
      };
    }

    // ¿Esta tela tiene AL MENOS UNA combinación válida con el otro lado?
    function isFabricViable(role, candCode){
      const { topBase, botBase } = getBaseCodes();
      if (!topBase || !botBase) return true;

      if (role === 'top'){
        const otherCodes = listFabricCodes('bottom');
        for (const bf of otherCodes){
          const sku = sku4(topBase, botBase, candCode, bf);
          if (sku && skuExists(sku)) return true;
        }
        return false;
      } else {
        const otherCodes = listFabricCodes('top');
        for (const tf of otherCodes){
          const sku = sku4(topBase, botBase, tf, candCode);
          if (sku && skuExists(sku)) return true;
        }
        return false;
      }
    }

    // Aplica el estado “no viable” también a los swatches de la card
    function applyViabilityToSwatches(role){
      const card = getSelectedCard(role);
      if (!card) return;
      [...card.querySelectorAll('.configurator-swatch')].forEach(sw => {
        const code = role === 'top'
          ? (sw.dataset.skuTopFabric || sw.dataset.fabric || '')
          : (sw.dataset.skuBottomFabric || sw.dataset.fabric || '');
        const ok = isFabricViable(role, code);
        sw.disabled = !ok;
        sw.classList.toggle('is-unavailable', !ok);
        sw.setAttribute('aria-disabled', ok ? 'false' : 'true');
      });
    }

    // Si la tela activa ya no es viable, autoelige la primera viable
    function enforceViableSelection(role){
      const card = getSelectedCard(role);
      if (!card) return;
      const active = card.querySelector('.configurator-swatch.is-active');
      const isActiveOk = active ? !active.disabled : false;
      if (isActiveOk) return;

      const firstOk = [...card.querySelectorAll('.configurator-swatch')].find(s => !s.disabled);
      if (firstOk && !CFG_SYNCING){
        CFG_SYNCING = true;
        firstOk.click();
        CFG_SYNCING = false;
      }
    }

    function selectFirstViableForRole(role, preferredName){
      const card = getSelectedCard(role);
      if (!card) return false;

      const swatches = [...card.querySelectorAll('.configurator-swatch')];
      const getCode = (s) => role === 'top'
        ? (s.dataset.skuTopFabric || s.dataset.fabric || '')
        : (s.dataset.skuBottomFabric || s.dataset.fabric || '');

      let target = null;
      if (preferredName && preferredName !== '—') {
        target = swatches.find(s =>
          s.dataset.fabric === preferredName && isFabricViable(role, getCode(s)));
      }

      if (!target) target = swatches.find(s => isFabricViable(role, getCode(s)));

      if (!target) target = swatches[0] || null;

      if (target){
        target.click();
        return true;
      }
      return false;
    }

    function candidateSkuFor(targetRole, fabCode){
      const topSw = getActiveSwatch('top');
      const botSw = getActiveSwatch('bottom');
      if (!topSw || !botSw) return '';

      const topBase = topSw.dataset.skuTopBase || '';
      const botBase = botSw.dataset.skuBottomBase || '';
      const topFab  = topSw.dataset.skuTopFabric || '';
      const botFab  = botSw.dataset.skuBottomFabric || '';
      if (!topBase || !botBase) return '';

      return targetRole === 'top'
        ? `${topBase}_${botBase}_${fabCode || topFab}_${botFab}`
        : `${topBase}_${botBase}_${topFab}_${fabCode || botFab}`;
    }

    function filterSideByFinal(targetRole){
      if (!SKU_INDEX || !Object.keys(SKU_INDEX).length) return;

      const card = getSelectedCard(targetRole);
      if (!card) return;

      const other = targetRole === 'top' ? 'bottom' : 'top';
      if (!getActiveSwatch(other)) return;

      const swatches = [...card.querySelectorAll('.configurator-swatch')];

      for (const sw of swatches){
        const code = targetRole === 'top'
          ? (sw.dataset.skuTopFabric || sw.dataset.fabric || '')
          : (sw.dataset.skuBottomFabric || sw.dataset.fabric || '');

        const cand = candidateSkuFor(targetRole, code);
        const ok   = !!cand && skuExists(cand);

        sw.disabled = !ok;
        sw.classList.toggle('is-unavailable', !ok);
        sw.setAttribute('aria-disabled', ok ? 'false' : 'true');
      }

      const active = card.querySelector('.configurator-swatch.is-active');
      if (active && active.disabled){
      const firstValid = swatches.find(s => !s.disabled);
      if (firstValid){
        if (!CFG_SYNCING){
          CFG_SYNCING = true;
          firstValid.click();
          CFG_SYNCING = false;
        }
      }
    }

      syncMenuDisabledFromCard(targetRole);
    }
    // === PARCHE (ocultar telas que NO forman SKU final) ===



    // Refleja en el dropdown qué telas están deshabilitadas
    function syncMenuDisabledFromCard(role){
      const root = role === 'top' ? topSelectUI : bottomSelectUI;
      const card = getSelectedCard(role);
      const menu = root?.querySelector('.cfg-fabric-menu');
      if (!root || !card || !menu) return;

      [...menu.querySelectorAll('.cfg-fabric-option')].forEach(li => {
        const fabric = li.dataset.fabric || '';
        const sw = [...card.querySelectorAll('.configurator-swatch')]
          .find(s => (s.dataset.fabric || (role==='top'?s.dataset.skuTopFabric:s.dataset.skuBottomFabric)) === fabric);
        const unavailable = !!sw?.disabled;
        li.classList.toggle('is-unavailable', unavailable);
        li.setAttribute('aria-disabled', unavailable ? 'true' : 'false');
      });
    }

    function updateCompatibility(){
      syncMenuDisabledFromCard('top');
      syncMenuDisabledFromCard('bottom');
    }

  /******************************************************************
   * 7) PRESELECCIÓN + ADD TO CART
   ******************************************************************/
  function preselectDefaults(){
    const pickFirstCard = (gridSel) => document.querySelector(`${gridSel} .configurator-item`) || null;

    const selectCard = (card, isTop) => {
      if (!card) return;
      const gridSel = isTop ? '#tops-grid' : '#bottoms-grid';
      document.querySelectorAll(`${gridSel} .configurator-item`).forEach(c => c.classList.remove('is-selected'));
      card.classList.add('is-selected');
      const title = card.dataset.title || '—';
      if (isTop) topSummary.textContent = title; else bottomSummary.textContent = title;
    };
    const selectFirstSwatch = (card, isTop) => {
      if (!card) return;
      const first = Array.from(card.querySelectorAll('.configurator-swatch'))[0];
      if (!first) return;
      card.querySelectorAll('.configurator-swatch').forEach(s => s.classList.remove('is-active'));
      first.classList.add('is-active');
      const fabric = first.dataset.fabric || '—';
      if (isTop) topFabricSummary.textContent = fabric; else bottomFabricSummary.textContent = fabric;
    };

    const topCard = pickFirstCard('#tops-grid');   selectCard(topCard, true);  selectFirstSwatch(topCard, true);
    const bottomCard = pickFirstCard('#bottoms-grid'); selectCard(bottomCard, false); selectFirstSwatch(bottomCard, false);

    checkReady(); updatePreview();
    buildFabricMenu('top'); buildFabricMenu('bottom');

    updateCompatibility();
    
  }

  // === TRY DEDUPE HELPERS (evitar duplicados de MISMO VESTIDO + MISMA TALLA)
  async function readCart() {
    try {
      return await fetch('/cart.js', {
        credentials: 'same-origin',
        cache: 'no-store'
      }).then(r => r.json());
    } catch {
      return { items: [] };
    }
  }

  function isTryLine(item) {
    // Detecta líneas del carrito que provienen de Try it at Home
    return (item.properties?.['Purchase Mode'] || '').toLowerCase() === 'try it at home';
  }

  // ADD TO CART
  addBtn?.addEventListener('click', async (e) => {
    e.preventDefault();

    const modeVal = document.querySelector('input[name="cfg-mode"]:checked')?.value || 'mto';

    let variantIdStr = null;
    let properties = {};

    // Propiedades comunes
    const propsBase = {
      // Top:   document.getElementById('cfg-summary-top')?.textContent?.trim() || '',
      // Skirt: document.getElementById('cfg-summary-bottom')?.textContent?.trim() || '',
      // Style: [
      //   document.getElementById('cfg-summary-top-fabric')?.textContent,
      //   document.getElementById('cfg-summary-bottom-fabric')?.textContent
      // ].filter(Boolean).join(' / ')
    };

    if (modeVal === 'try') {
      // ===== TRY IT AT HOME =====
      const v = window.__CFG_TRY__?.getSelectedTryVariant?.();
      if (!v || !v.id) {
        alert('Please select a size for Try it at Home.');
        return;
      }

      variantIdStr = String(v.id).split('/').pop();

      const finalTitle  = window.CFG_FINAL_TITLE  || document.getElementById('cfg-final-name')?.textContent?.trim() || '';
      const finalHandle = window.CFG_FINAL_HANDLE || (document.querySelector('.cfg-preview-link')?.getAttribute('href')||'').split('/products/')[1] || '';
      const finalURL    = finalHandle ? `/products/${finalHandle}` : '#';
      const finalImage  = document.querySelector('.configurator-preview-main img')?.src || window.CFG_FINAL_IMAGE || '';

      const sizeKey = String(v.size || '').toUpperCase();
      const tryKey  = `${finalHandle}::${sizeKey}`;

      const cart = await readCart();
      const duplicate = cart.items.some(it => {
        if (!isTryLine(it)) return false;

        const itKey = String(it.properties?.['Try Key'] || '');
        if (itKey) return itKey === tryKey;

        const itUrl  = String(it.properties?.['Try Dress URL'] || '').split('?')[0];
        const itSize = String(it.properties?.['Try Size'] || '').toUpperCase();
        return (itUrl === finalURL && itSize === sizeKey);
      });

      if (duplicate) {
        alert('You already added this dress in that size.');
        return;
      }

      // properties = {
      //   ...propsBase,
      //   'Purchase Mode': 'Try it at Home',
      //   'Try Size': v.size || '',
      //   'Try Dress Title': finalTitle,
      //   'Try Dress URL': finalURL,
      //   'Try Dress Image': finalImage,
      //   'Try Key': tryKey
      // };

      properties = {
        ...propsBase,
        'Purchase Mode': 'Try it at Home',
        'Try Size': v.size || '',
        'Try Dress Title': finalTitle,
        // 'Try Dress Handle': finalHandle,
        'Try Dress URL': finalURL,
        'Try Dress Image': finalImage
      };
      


    } else {
      // ===== MTO =====
      if (!CURRENT_VARIANT_GID) return;

      //usa la variable local `measure`, no `window.measure`
      if (typeof REQUIRE_MEASUREMENT !== 'undefined' && REQUIRE_MEASUREMENT && !measure?.id) {
        alert('Please complete your online measurement first.');
        return;
      }

      variantIdStr = String(CURRENT_VARIANT_GID).split('/').pop();

      properties = {
        ...propsBase,
        'Measured ID': measure?.id ? String(measure.id) : '',
        'Purchase Mode': 'Made to Order'
      };
    }

    const payload = {
      items: [{
        id: variantIdStr,
        quantity: 1,
        properties
      }]
    };

    try {
      addBtn.disabled = true;

      const drawerEl = document.querySelector('cart-drawer');
      const sections = drawerEl?.getSectionsToRender?.().map(s => s.id) ?? ['cart-drawer','cart-icon-bubble'];

      const qs = new URLSearchParams();
      qs.set('sections', sections.join(','));
      qs.set('sections_url', window.location.pathname);

      let res = await fetch(`/cart/add.js?${qs}`, {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'Cache-Control': 'no-store' },
        body: JSON.stringify(payload)
      });

      let parsed = null;

      if (!res.ok) {
        const res2 = await fetch('/cart/add.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'Cache-Control': 'no-store' },
          body: JSON.stringify(payload)
        });
        if (!res2.ok) {
          let msg = 'There was a problem adding to cart.';
          try { const je = await res2.json(); if (je?.description) msg = je.description; } catch {}
          alert(msg); return;
        }
        parsed = await res2.json().catch(()=> ({}));

        if (drawerEl) {
          const bust = Date.now();
          const url = `${location.pathname}?sections=${encodeURIComponent(sections.join(','))}&t=${bust}`;
          const htmlMap = await fetch(url, {
            headers: { 'Accept': 'application/json', 'Cache-Control': 'no-cache' },
            credentials: 'same-origin'
          }).then(r => r.json()).catch(()=>null);
          if (htmlMap) drawerEl.renderContents({ sections: htmlMap, id: parsed.id });
          else drawerEl?.open?.();
        }

      } else {
        parsed = await res.json().catch(() => ({}));
        if (parsed.sections_html && !parsed.sections) parsed.sections = parsed.sections_html;
        if (drawerEl && parsed.sections) drawerEl.renderContents(parsed);
      }

      let itemCount = typeof parsed?.item_count === 'number' ? parsed.item_count : null;
      if (itemCount == null) {
        try { const cart = await fetch('/cart.js', { cache: 'no-store', credentials: 'same-origin' }).then(r=>r.json()); itemCount = cart?.item_count ?? 0; }
        catch { itemCount = 1; }
      }
      if (drawerEl) {
        drawerEl.classList.toggle('is-empty', itemCount === 0);
        drawerEl.classList.add('active');
        requestAnimationFrame(() => {
          window.dispatchEvent(new Event('resize'));
          if (window.jQuery?.fn?.slick) { try { jQuery('.collection_slider').slick('setPosition'); } catch {} }
        });
      }

      const oldTxt = addBtn.textContent;
      addBtn.textContent = 'Added!';
      setTimeout(() => { addBtn.textContent = oldTxt; }, 1200);
      document.dispatchEvent(new CustomEvent('product:added', { detail: { id: Number(variantIdStr) || null } }));

    } finally {
      addBtn.disabled = false;
    }
  });

  /******************************************************************
   * 8) CARRUSELES
   ******************************************************************/
  (function initCarousels(){
    const GAP = 16;
    document.querySelectorAll('.cfg-carousel').forEach(root => {
      const track = root.querySelector('[data-carousel="track"]');
      if (!track) return;
      const prev = root.querySelector('.cfg-th-prev') || root.querySelector('.cfg-nav.cfg-prev');
      const next = root.querySelector('.cfg-th-next') || root.querySelector('.cfg-nav.cfg-next');
      const getStep = () => {
        const card = track.querySelector('.configurator-item');
        return card ? Math.round(card.getBoundingClientRect().width + GAP) : Math.round(track.clientWidth * 0.9);
      };
      function updateArrows(){
        const max = track.scrollWidth - track.clientWidth - 1;
        if (prev) prev.disabled = track.scrollLeft <= 0;
        if (next) next.disabled = track.scrollLeft >= max;
      }
      function go(dir){ track.scrollBy({ left: dir * getStep(), behavior: 'smooth' }); }
      prev?.addEventListener('click', () => go(-1));
      next?.addEventListener('click', () => go(+1));
      track.addEventListener('scroll', () => requestAnimationFrame(updateArrows));
      window.addEventListener('resize', updateArrows);
      updateArrows();
    });
  })();

  function initThumbsControls() {
    const wrap  = document.querySelector('.cfg-thumbs'); if (!wrap) return;
    const track = wrap.querySelector('#cfg-thumbs');
    const prev  = wrap.querySelector('.cfg-th-prev');
    const next  = wrap.querySelector('.cfg-th-next');
    if (!track || !prev || !next) return;

    const GAP = 10;
    const getStep = () => {
      const t = track.querySelector('.cfg-thumb');
      return t ? Math.round(t.getBoundingClientRect().width + GAP) : Math.round(track.clientWidth * 0.9);
    };

    const go = (dir) => track.scrollBy({ left: dir * getStep(), behavior: 'smooth' });
    prev.onclick = () => go(-1);
    next.onclick = () => go( 1);

    const update = () => {
      const max = track.scrollWidth - track.clientWidth - 1;
      prev.disabled = track.scrollLeft <= 0;
      next.disabled = track.scrollLeft >= max;
    };

    track.addEventListener('scroll', () => requestAnimationFrame(update), { passive: true });
    window.addEventListener('resize', update);
    update();
  }

  /******************************************************************
   * 9) INIT + QUIZ FILTERS
   ******************************************************************/
  (async function init(){
    await loadTopsAndBottoms();
    wireInteractions();

    await ensureFabricIndex();
    await buildSkuIndex();

    preselectDefaults();
    checkReady();
    updateCompatibility();


    restoreMeasurementFromLocalStorage();
    applyInitialCTAState();
    wireAccordions();

    syncQuizTopbar();

  })();

  // === Wishlist ===
  (function wireCfgWishlist(){
    const btn = document.getElementById('cfg-wishlist');
    if (!btn) return;

    btn.addEventListener('click', async (ev) => {
      ev.preventDefault();

      if (btn.dataset.busy === '1') return;
      btn.dataset.busy = '1';

      const epi  = Number(btn.dataset.epi || btn.dataset.variantId || 0);
      let empi   = Number(btn.dataset.empi || 0);

      if (!empi) {
        const handleFromUrl = (btn.dataset.productUrl || '').split('/products/')[1]?.split('?')[0] || '';
        empi = await fetchProductIdByHandle(handleFromUrl) || 0;
        if (empi) btn.setAttribute('data-empi', String(empi));
      }

      if (!epi || !empi) {
        console.warn('[Swym] faltan ids', { epi, empi });
        btn.dataset.busy = '0';
        return;
      }

      const product = {
        epi,
        empi,
        du: btn.dataset.productUrl || location.href,
        dt: btn.dataset.productTitle || 'Custom Dress',
        iu: btn.dataset.imageUrl || '',
        pr: Number(btn.dataset.price || 0)
      };

      if (btn.dataset.sku) product.sku = btn.dataset.sku;

      try {
        const lists = await ensureDefaultList();
        const { found, lid } = isInWishlist(lists, epi, empi);

        onSwymReady(()=>{
          try{
            const done = async () => {
              await syncWishlistState();
              btn.dataset.busy = '0';
            };
            const fail = (err) => { console.warn('[Swym] list op error', err); btn.dataset.busy = '0'; };

            if (found) {
              window._swat.deleteFromList(lid, product, done, fail);
            } else {
              window._swat.addToList(lid, product, done, fail);
            }
          } catch(e){
            console.error('[Swym] toggle wishlist error', e);
            btn.dataset.busy = '0';
          }
        });
      } catch(e){
        console.error('[Swym] toggle outer error', e);
        btn.dataset.busy = '0';
      }
    }, { passive: false });
  })();

  const QUIZ_FILTERS_KEY = 'CFG_QUIZ_FILTERS';

  function readQuizFilters() {
    try {
      const j = JSON.parse(localStorage.getItem(QUIZ_FILTERS_KEY) || 'null');
      if (!j) return null;
      return { tops: Array.isArray(j.tops) ? j.tops : [], bottoms: Array.isArray(j.bottoms) ? j.bottoms : [] };
    } catch { return null; }
  }

  function hasQuizFilters(){
    const q = readQuizFilters();
    return !!(q && ((q.tops?.length) || (q.bottoms?.length)));
  }

  function syncQuizTopbar(){
    const has = hasQuizFilters();
    const appliedEl = document.getElementById('cfg-quiz-applied');
    const linkEl    = document.getElementById('cfg-open-quiz');
    if (appliedEl) appliedEl.hidden = !has;

    if (linkEl){
      linkEl.hidden = has;
      linkEl.setAttribute('aria-hidden', String(has));
      linkEl.classList.toggle('is-applied', has);
    }
  }

  window.addEventListener('cfg:applyQuizFilters', async (ev) => {
    localStorage.setItem(QUIZ_FILTERS_KEY, JSON.stringify(ev.detail || {}));
    await loadTopsAndBottoms();
    wireInteractions();
    preselectDefaults?.();
    buildFabricMenu('top'); buildFabricMenu('bottom');
    checkReady();
    await buildSkuIndex?.();
    updatePreview();

    syncQuizTopbar();

  });
  

  document.getElementById('cfg-clear-quiz')?.addEventListener('click', (e) => {
    e.preventDefault(); clearQuizFilters();
  });

  function clearQuizFilters() {
    localStorage.removeItem(QUIZ_FILTERS_KEY);
    syncQuizTopbar(); 
    window.dispatchEvent(new CustomEvent('cfg:applyQuizFilters', { detail: { tops: [], bottoms: [] } }));

  }

  // ===== Escuchar mensajes del widget 3DLOOK (measurement_id)
  window.addEventListener('message', (evt) => {
    if (!evt.origin || !evt.origin.includes('3dlook.me')) return;
    const data = evt.data || {};

    // Observa en consola la primera vez para confirmar nombres exactos
    console.debug('3DLOOK payload:', data);

    const mid =
      data.measurement_id ||
      data.id ||
      (data.payload && data.payload.measurement_id) ||
      null;

    if (mid) {
      measure.id        = String(mid);
      measure.sessionId = data.session_id || (data.payload && data.payload.session_id) || null;
      measure.reportUrl = data.report_url || (data.payload && data.payload.report_url) || null;

      if (measuredIdSpan) measuredIdSpan.textContent = measure.id;
      if (measuredBadge) measuredBadge.hidden = false;

      checkReady();
    }
  });

  function markMeasured(mid, extra = {}) {
    if (!mid) return;
    measure.id        = String(mid);
    measure.sessionId = extra.sessionId || measure.sessionId || null;
    measure.reportUrl = extra.reportUrl || measure.reportUrl || null;

    if (measuredIdSpan) measuredIdSpan.textContent = measure.id;
    if (measuredBadge)  measuredBadge.hidden = false;

    persistMeasurement(measure.id);

    showMeasureCTA(false);
    showAddToCart(true);
    updatePurchaseModeState?.(); 
    checkReady();

    document.body.classList.add('cfg-measured');

    // console.debug('[3DLOOK] measured ✔', { id: measure.id, ...extra });
    document.getElementById('saia_measurement_id')?.setAttribute('value', measure.id);
  }

  // ===== 3DLOOK: capturar measurement_id de manera robusta
  (function listen3DLookMessages(){
    const ORIGIN_OK = /(3dlook|saia)/i;

    function deepFindId(obj){
      try {
        const q = [obj];
        while (q.length){
          const v = q.shift();
          if (!v || typeof v !== 'object') continue;
          for (const [k,val] of Object.entries(v)){
            if (val && typeof val === 'object'){ q.push(val); continue; }
            if (typeof val === 'string'){
              if (/(measurement|person).*id/i.test(k) || /^id$/i.test(k)){
                if (/^[0-9a-f-]{8,}$/i.test(val) || val.length >= 6) return val;
              }
              if (val.startsWith('{') && val.endsWith('}')){
                try { const found = deepFindId(JSON.parse(val)); if (found) return found; } catch {}
              }
            }
            if (typeof val === 'number' && /^id$|person_id|measurement_id/i.test(k)) {
              return String(val);
            }
          }
        }
      } catch {}
      return null;
    }

    window.addEventListener('message', (evt) => {
      // console.log('[3DLOOK message]', evt.origin || '(no-origin)', evt.data);
      if (evt.origin && !ORIGIN_OK.test(evt.origin)) return;

      const mid = deepFindId(evt.data || {});
      if (mid) {
        markMeasured(mid, { source: 'postMessage' });
        window.__CFG_MEAS_POLL__?.stop?.();
      } else {
        window.__CFG_MEAS_POLL__?.start?.();
      }
    }, false);
  })();

  // ===== detecta el ID en localStorage (saia-pf-widget-data)
  (function measurementPolling(){
    let timer = null, startedAt = 0;

    function scanOnce() {
      try {
 
        const raw = localStorage.getItem('saia-pf-widget-data');
        if (raw) {
          let j; try { j = JSON.parse(raw); } catch { j = null; }
          if (j && typeof j === 'object') {
            const id = String(j.id || j.person_id || j.measurement_id || '');
            const ready = !!(j.task_set && j.task_set.is_ready === true);
            if (id && (ready || Date.now() - startedAt > 2000)) {
              markMeasured(id, { source: 'heartbeat' });
              stop(); return true;
            }
          }
        }

        for (const [k, vRaw] of Object.entries(localStorage)) {
          if (!/3dlook|saia|mtm/i.test(k)) continue;
          if (!vRaw) continue;
          let v; try { v = JSON.parse(vRaw); } catch { v = vRaw; }
          const id2 =
            v?.measurement_id || v?.measurements_id || v?.person_id || v?.id ||
            (typeof v === 'string' && (v.match(/[0-9a-f-]{8,}/i)?.[0]));
          if (id2) { markMeasured(String(id2), { source: 'heartbeat-scan', key: k }); stop(); return true; }
        }
      } catch {}
      return false;
    }

    function start() {
      if (timer) return;
      startedAt = Date.now();
      timer = setInterval(() => {
        const got = scanOnce();
        if (got || Date.now() - startedAt > 180000) stop();
      }, 700);
      scanOnce();
    }
    function stop(){ if (timer) clearInterval(timer); timer = null; }

    document.addEventListener('click', start, { passive: true });
    document.addEventListener('visibilitychange', () => { if (!document.hidden) start(); });
    window.addEventListener('focus', start);

    const mo = new MutationObserver((muts) => {
      for (const m of muts) {
        for (const n of m.addedNodes) {
          if (n.nodeType !== 1) continue;
          const el = /** @type {HTMLElement} */(n);
          const src = el.tagName === 'IFRAME' ? (el.getAttribute('src') || '') : '';
          if ((el.tagName === 'IFRAME' && /(3dlook|saia)/i.test(src)) ||
              (el.id && /saia|mtm/i.test(el.id)) ||
              (String(el.className||'').match(/saia|mtm/i))) {
            start();
          }
        }
        for (const n of m.removedNodes) {
          if (n.nodeType !== 1) continue;
          const el = /** @type {HTMLElement} */(n);
          const src = el.tagName === 'IFRAME' ? (el.getAttribute('src') || '') : '';
          if (el.tagName === 'IFRAME' && /(3dlook|saia)/i.test(src)) { scanOnce(); stop(); }
        }
      }
    });
    mo.observe(document.body, { childList: true, subtree: true });

    window.__CFG_MEAS_POLL__ = { start, stop, scanOnce };

    window.markMeasured = window.markMeasured || markMeasured;
    window.CFG_fake3DLOOK = () => {
      window.dispatchEvent(new MessageEvent('message', {
        origin: 'https://saia.3dlook.me',
        data: { measurement_id: 'demo-' + Date.now(), session_id: 'sess-xyz' }
      }));
    };
  })();


  (function hookPostMessage(){
    const KNOWN_ORIGINS = ['3dlook.me','3dlook.ai','mtm-widget.3dlook.me','saia.3dlook.me'];
    window.addEventListener('message', (evt) => {

      // Log siempre (temporalmente) para ver formato real
      // console.debug('[3DLOOK postMessage]', evt.origin, evt.data);

      if (evt.origin && !KNOWN_ORIGINS.some(dom => evt.origin.includes(dom))) return;

      const d = evt.data || {};
  
      const mid =
        d.measurement_id || d.measurements_id || d.person_id || d.id ||
        d?.payload?.measurement_id || d?.payload?.measurements_id || d?.payload?.id || null;

      const sid = d.session_id || d?.payload?.session_id || null;
      const rep = d.report_url || d?.payload?.report_url || null;

      if (mid) markMeasured(mid, { sessionId: sid, reportUrl: rep, source: 'postMessage' });
    }, false);
  })();


  (function watchWidgetContainer(){
    const el = document.getElementById('saia-widget-container');
    if (!el) return;
    const tryExtract = () => {
      
      const attrMid = el.getAttribute('data-measurement-id')
                  || el.dataset?.measurementId
                  || el.querySelector('[data-measurement-id]')?.getAttribute('data-measurement-id')
                  || null;
      if (attrMid) markMeasured(attrMid, { source: 'mutation' });
    };
    const mo = new MutationObserver(() => tryExtract());
    mo.observe(el, { attributes: true, childList: true, subtree: true });
    tryExtract();
  })();

  // === 3) escanear localStorage tras cerrar el widget ===
  (function probeLocalStorage(){
    let tries = 0, timer = null;
    function scan() {
      tries++;
      try {
        for (const [k, v] of Object.entries(localStorage)) {
          if (!/3dlook|saia|mtm/i.test(k)) continue;
          if (!v) continue;
  
          let val = null;
          try { val = JSON.parse(v); } catch { val = v; }
          const mid =
            val?.measurement_id || val?.measurements_id || val?.person_id || val?.id ||
            (typeof val === 'string' && val.match(/[0-9a-f-]{8,}/i)?.[0]);
          if (mid) { markMeasured(mid, { source: 'localStorage', key: k }); stop(); return; }
        }
      } catch(e){ /* ignore */ }
      if (tries > 60) stop();
    }
    function stop(){ if (timer) clearInterval(timer); timer = null; }

    document.addEventListener('click', (e) => {
      if (e.target.closest('#saia-widget-container')) {
        if (!timer) timer = setInterval(scan, 1000);
      }
    });
  })();

  /* ================================================================
   TRY IT AT HOME — MÓDULO ENCAPSULADO
   ================================================================= */
  (() => {
    const TRY_FEATURE_ENABLED = true;

    const tryBlock     = document.getElementById('cfg-try-block');
    const trySizesWrap = document.getElementById('cfg-try-sizes');
    const tryUnavail   = document.getElementById('cfg-try-unavail');
    const modeMTO      = document.getElementById('cfg-mode-mto');
    const modeTRY      = document.getElementById('cfg-mode-try');
    const tryPriceEl   = document.getElementById('cfg-try-price');
    const tryHint     = document.querySelector('.cfg-try-hint');
    const tryArrives     = document.getElementById('cfg-try-arrives');

    const CLEAR_TRY_SELECTION_ON_MODE_SWITCH = true; // limpiar selección al volver de mto a Try para recordar la talla solo poner false

    const TRY_KNOWN_SIZES = ['S','M','L','XL'];
    const TRY_ALLOWED_CACHE = new Map();
    let TRY_PRODUCT_HANDLE = null;
    let TRY_VARIANTS = [];
    let TRY_SELECTED = null;
    let CURRENT_FINAL_HANDLE = null;
    let TRY_SIZE_STATUS = 'none';

    function setTrySelected(v){
      TRY_SELECTED = v || null;
      window.TRY_SELECTED = TRY_SELECTED;
      TRY_SIZE_STATUS = v ? 'available' : 'none';

    }

    async function ensureTryData() {
      let srcHandle = null;
      try {
        const src = JSON.parse(document.getElementById('cfg-sources')?.textContent || '{}');
        srcHandle = (src?.try?.product || '').trim() || 'try-it-at-home';
      } catch {
        srcHandle = 'try-it-at-home';
      }

      if (TRY_PRODUCT_HANDLE === srcHandle && TRY_VARIANTS.length) return;
      TRY_PRODUCT_HANDLE = srcHandle;

      const q = `
        query($h:String!){
          product(handle:$h){
            variants(first: 100){
              edges{
                node{
                  id
                  title
                  availableForSale
                  price{ amount currencyCode }
                  selectedOptions{ name value }
                }
              }
            }
          }
        }`;
      const j = await gql(q, { h: TRY_PRODUCT_HANDLE });
      const edges = j?.data?.product?.variants?.edges || [];

      TRY_VARIANTS = edges.map(e => {
        const n = e?.node || {};
        const size = (n.selectedOptions || []).find(o => (o?.name || '').toLowerCase()==='size')?.value || n.title || '';
        return {
          id: n.id,
          size: String(size).toUpperCase(),
          availableForSale: !!n.availableForSale,
          priceAmount: Number(n?.price?.amount ?? 0),
          currency: n?.price?.currencyCode || 'USD'
        };
      }).filter(v => TRY_KNOWN_SIZES.includes(v.size));
    }

    async function fetchAllowedSizesForHandle(handle){
      if (!handle) return TRY_KNOWN_SIZES;
      if (TRY_ALLOWED_CACHE.has(handle)) return TRY_ALLOWED_CACHE.get(handle);

      const q = `
        query($h:String!){
          product(handle:$h){
            metafield(namespace:"try", key:"sizes"){ value }
          }
        }`;
      const j = await gql(q, { h: handle });
      let raw = j?.data?.product?.metafield?.value || '';
      let list = [];
      try {
        raw = String(raw).trim();
        if (!raw) list = [];
        else if (raw.startsWith('[')) list = JSON.parse(raw); // JSON ["S","M"]
        else list = raw.split(',');                            // CSV  S,M,L
      } catch { list = String(raw).split(','); }

      const out = list.map(s => String(s).trim().toUpperCase()).filter(s => TRY_KNOWN_SIZES.includes(s));
      const res = out.length ? out : TRY_KNOWN_SIZES;
      TRY_ALLOWED_CACHE.set(handle, res);
      return res;
    }

    function showTryUI(show){
      if (!tryBlock) {
        showAddToCart(true);
        return;
      }
      tryBlock.hidden = !show;

      if (!tryArrives) {
        showAddToCart(true);
        return;
      }
      tryArrives.hidden = !show;

      if (show){
        showAddToCart(true);

        if (tryHint)    tryHint.hidden = false;
        if (tryUnavail) tryUnavail.hidden = true;

        if (addBtn) {
          const hasSize = !!TRY_SELECTED;
          addBtn.disabled    = !hasSize;
          addBtn.textContent = hasSize ? 'ADD TO CART' : 'SELECT YOUR SIZE';
        }
      } else {
        if (tryUnavail) tryUnavail.hidden = true;
      }
    }


    function renderTrySizes(allowedSizes = TRY_KNOWN_SIZES){
      if (!trySizesWrap) return;
      trySizesWrap.innerHTML = '';

      const bySize = Object.fromEntries((TRY_VARIANTS || []).map(v => [String(v.size).toUpperCase(), v]));

      TRY_KNOWN_SIZES.forEach(sz => {
        const v = bySize[sz];
        const allowed  = allowedSizes.includes(sz);
        const sellable = !!v?.availableForSale || (v?.quantityAvailable > 0);
        const usable   = !!v?.id && allowed && sellable;

        const b = document.createElement('button');
        b.type = 'button';
        b.className = 'size-btn' + (usable ? '' : ' is-unavailable');
        b.textContent = sz;
        b.dataset.vid = v?.id || '';

        if (!usable) {
          // Deja clickeable para que el CTA muestre "SIZE UNAVAILABLE"
          b.setAttribute('aria-disabled', 'true');
          b.addEventListener('click', () => {
            trySizesWrap.querySelectorAll('.size-btn').forEach(x => x.classList.remove('is-selected'));
            setTrySelected(null);
            TRY_SIZE_STATUS = 'unavailable';

            if (addBtn) {
              addBtn.disabled = true;
              addBtn.textContent = 'SIZE UNAVAILABLE';
            }

            if (tryUnavail) {
              tryUnavail.textContent = 'Size currently unavailable. Please come back later.';
              tryUnavail.hidden = false;
            }
            if (tryHint) tryHint.hidden = true;
          });
        } else {
          b.addEventListener('click', () => {
            trySizesWrap.querySelectorAll('.size-btn').forEach(x => x.classList.remove('is-selected'));
            setTrySelected(v);
            b.classList.add('is-selected');
            TRY_SIZE_STATUS = 'available';

            if (addBtn) {
              addBtn.disabled = false;
              addBtn.textContent = 'ADD TO CART';
            }

            if (tryHint)    tryHint.hidden    = false;
            if (tryUnavail) tryUnavail.hidden = true;

            checkReady?.();
          });
        }

        trySizesWrap.appendChild(b);
      });

      if (TRY_SELECTED) {
        const btn = [...trySizesWrap.querySelectorAll('.size-btn')].find(b =>
          b.textContent === (TRY_SELECTED.size || '').toUpperCase() &&
          b.dataset.vid === String(TRY_SELECTED.id || '')
        );
        if (btn && !btn.classList.contains('is-unavailable')) {
          btn.classList.add('is-selected');
        }
      }

      if (tryHint)    tryHint.hidden    = false;
      if (tryUnavail) tryUnavail.hidden = true;

      if (addBtn) {
        const hasPreselected = !!TRY_SELECTED;
        addBtn.disabled    = !hasPreselected;
        addBtn.textContent = hasPreselected ? 'ADD TO CART' : 'SELECT YOUR SIZE';
        TRY_SIZE_STATUS  = hasPreselected ? 'available' : 'none';

      }
    }

    async function onTryContextChanged(){
      await ensureTryData();
      const allowed = await fetchAllowedSizesForHandle(CURRENT_FINAL_HANDLE);
      renderTrySizes(allowed);
      showTryUI(true);
      checkReady();
    }

    async function onPurchaseModeChange(){
      const modeVal = document.querySelector('input[name="cfg-mode"]:checked')?.value || 'mto';

      document.body.classList.toggle('cfg-mode-try', modeVal === 'try');
      document.body.classList.toggle('cfg-mode-mto', modeVal !== 'try');

      if (modeVal === 'try'){
        showMeasureCTA(false);
        showDisclaimer(false);
        if (mtoConfirm) mtoConfirm.checked = false;

        showAddToCart(true);

        if (CLEAR_TRY_SELECTION_ON_MODE_SWITCH) {
          setTrySelected(null);
        }

        await onTryContextChanged();
        return;
      }

      showTryUI(false);
      window.TRY_SELECTED = null;
      if (tryUnavail) tryUnavail.hidden = true;
      if (tryHint)    tryHint.hidden    = true;

      if (addBtn) addBtn.textContent = 'ADD TO CART';
      applyInitialCTAState();
      checkReady();
    }

    if (TRY_FEATURE_ENABLED){
      modeTRY?.addEventListener('change', onPurchaseModeChange);
      modeMTO?.addEventListener('change', onPurchaseModeChange)
      if (modeTRY?.checked) onPurchaseModeChange();
    }

    window.__CFG_TRY__ = {
      setCurrentFinalHandle(handle){
        CURRENT_FINAL_HANDLE = handle || null;
        const modeVal = document.querySelector('input[name="cfg-mode"]:checked')?.value || 'mto';
        if (modeVal === 'try') onTryContextChanged();
      },
      getSelectedTryVariant(){ return TRY_SELECTED; },
      getSizeStatus(){ return TRY_SIZE_STATUS; }
    };

  })();

});


//========= OPEN reamaze-widget 
document.addEventListener('DOMContentLoaded', () => {
  const btn = document.getElementById('cfg-chat-stylist');
  if (!btn) return;

  const tryOpenReamaze = () => {
    if (typeof window.Reamaze === 'function') {
      try { window.Reamaze('open'); return true; } catch(e) {}
      try { window.Reamaze('open:contact'); return true; } catch(e) {}
    }
    const icon = document.getElementById('reamaze-widget-icon')
            || document.querySelector('#reamaze-widget, [data-reamaze-id="icon"]');
    if (icon) { icon.click(); return true; }
    return false;
  };
  btn.addEventListener('click', (e) => {
    e.preventDefault();
    if (tryOpenReamaze()) return;
    let tries = 0;
    const iv = setInterval(() => {
      tries++;
      if (tryOpenReamaze() || tries > 20) clearInterval(iv);
    }, 250);
  });
});




/******************************************************************
 * MOBILE PREVIEW GALLERY (swipe + autoplay + cumulative progress)
 ******************************************************************/
const MOBILE_GALLERY = {
  activeKey: null,
  list: [], slides: [], root: null,
  idx: 0, len: 0,
  dur: 3500,
  auto: false,  // sin autoplay

  // timers (no se usan, pero los dejamos por si reactiva autoplay )
  t: null,
  raf: null,
  t0: 0,

  // barra
  bar: null,

  // touch
  touch: { x0: 0, x: 0, dragging: false },

  cleanup(){
    if (this.t)   { clearTimeout(this.t); this.t = null; }
    if (this.raf) { cancelAnimationFrame(this.raf); this.raf = null; }
    this.idx = 0; this.len = 0; this.list = []; this.slides = [];
    this.root?.querySelectorAll('.cfg-slide').forEach(n=>n.remove());
    this.root?.querySelector('.cfg-progress')?.remove();
    this.bar = null; this.activeKey = null;
    document.removeEventListener('visibilitychange', this.onVis);
    window.removeEventListener('resize', this.onResize);
  },

  mount(mainEl, key, urls){
    if (!window.matchMedia('(max-width: 900px)').matches) return;
    // if (this.activeKey === key && this.list.length) return;
    if (this.activeKey === key && this.list.length) {
      const hasSlides = mainEl.querySelector('.cfg-slide');
      if (hasSlides && this.root === mainEl) return;
    }


    this.cleanup();

    this.root = mainEl;
    this.activeKey = key;
    this.list = urls.slice();
    this.len  = this.list.length;
    this.idx  = 0;

    // Slides
    const frag = document.createDocumentFragment();
    urls.forEach((u, i) => {
      const s = document.createElement('div');
      s.className = 'cfg-slide';
      s.style.transform = `translateX(${i === 0 ? 0 : 100}%)`;
      s.innerHTML = `<img src="${u}" alt="">`;
      frag.appendChild(s);
      this.slides.push(s);
    });
    mainEl.innerHTML = '';
    mainEl.appendChild(frag);

    // Progress (solo si hay >1 imagen)
    if (this.len > 1) {
      const prog = document.createElement('div');
      prog.className = 'cfg-progress';
      prog.innerHTML = `<div class="cfg-progress-bar"></div>`;
      mainEl.appendChild(prog);

      this.bar = prog.firstElementChild;

      this.bar.style.removeProperty('width');
      this.bar.style.width = '100%';
      this.bar.style.transformOrigin = 'left center';
      
      // Primera imagen ya cuenta como “vista”: 1 / len
      const initial = 1 / this.len;
      this.bar.style.transform = `scaleX(${initial})`;
    } else {
      this.bar = null;
    }


    this.bindTouch();
    document.addEventListener('visibilitychange', this.onVis);
    window.addEventListener('resize', this.onResize);

    // Sin autoplay: fija el estado inicial de la barra
    this.updateBarImmediate();
  },

  // Sin autoplay: solo re-fijamos la barra si el tab vuelve a estar visible
  onVis: () => {
    if (!MOBILE_GALLERY.list.length) return;
    MOBILE_GALLERY.updateBarImmediate();
  },
  onResize: () => {},

  /* ===== Navegación ===== */
  positionSlides(){
    const cur  = this.idx;
    const prev = (cur - 1 + this.len) % this.len;
    const next = (cur + 1) % this.len;
    this.slides.forEach((s,i)=>{
      s.style.transition = 'none';
      if (i === cur)  s.style.transform = 'translateX(0%)';
      else if (i === prev) s.style.transform = 'translateX(-100%)';
      else if (i === next) s.style.transform = 'translateX(100%)';
      else s.style.transform = 'translateX(100%)';
    });
  },

  applyDrag(dx){
    const cur  = this.idx;
    const prev = (cur - 1 + this.len) % this.len;
    const next = (cur + 1) % this.len;
    this.slides[cur].style.transform  = `translateX(${dx}%)`;
    this.slides[next].style.transform = `translateX(${100+dx}%)`;
    this.slides[prev].style.transform = `translateX(${-100+dx}%)`;
  },

  snapBack(){
    const cur  = this.idx;
    const prev = (cur - 1 + this.len) % this.len;
    const next = (cur + 1) % this.len;
    [cur,prev,next].forEach(i=> this.slides[i].style.transition = 'transform .22s ease');
    this.slides[cur].style.transform  = 'translateX(0%)';
    this.slides[next].style.transform = 'translateX(100%)';
    this.slides[prev].style.transform = 'translateX(-100%)';
  },

  goto(n){
    if (!this.len) return;
    const old = this.idx;
    this.idx = (n + this.len) % this.len;

    this.slides[old].style.transition = 'transform .28s ease';
    this.slides[this.idx].style.transition = 'transform .28s ease';
    this.slides[old].style.transform = 'translateX(-100%)';
    this.slides[this.idx].style.transform = 'translateX(0%)';

    const next = (this.idx + 1) % this.len;
    this.slides[next].style.transition = 'none';
    this.slides[next].style.transform  = 'translateX(100%)';

    // Sin autoplay: barra por “saltos” acumulados
    this.updateBarImmediate();
  },
  next(){ this.goto(this.idx + 1); },
  prev(){ this.goto(this.idx - 1); },

  /* ===== Barra (acumulada, sin animación temporal) ===== */
  updateBarImmediate(){
    if (!this.bar || this.len <= 1) return;
    const seen = (this.idx + 1) / this.len;
    this.bar.style.transform = `scaleX(${seen})`;
  },
  

  // (queda por si se reactiva el autoplay algún día)
  updateBarRaf(now){
    if (!this.bar || this.len <= 1) return;
    const elapsed  = Math.max(0, now - this.t0);
    const fracImg  = Math.min(elapsed / this.dur, 1);
    const total    = (this.idx + fracImg) / this.len;
    this.bar.style.transform = `scaleX(${total})`;
    this.raf = requestAnimationFrame(this.updateBarRaf.bind(this));
  },

  /* ===== Gestos ===== */
  bindTouch(){
    const el = this.root;
    const t = this.touch;
    const SWIPE_PX = 40;       // umbral para cambiar de slide
    const LOCK_PX  = 8;        // umbral para decidir eje (pequeño)

    // extendemos el estado:
    t.y0 = 0;
    t.y  = 0;
    t.lock = null; // 'x' (horizontal) | 'y' (vertical) | null (indefinido)

    const onStart = (e) => {
      if (!window.matchMedia('(max-width: 900px)').matches) return;
      const pt = (e.touches ? e.touches[0] : e);
      t.dragging = true;
      t.x0 = pt.clientX;
      t.y0 = pt.clientY;
      t.x  = 0;
      t.y  = 0;
      t.lock = null; // resetea el eje
      this.positionSlides();
    };

    const onMove = (e) => {
      if (!t.dragging) return;
      const pt = (e.touches ? e.touches[0] : e);
      t.x = pt.clientX - t.x0;
      t.y = pt.clientY - t.y0;

      // decidir eje una sola vez cuando supera LOCK_PX
      if (t.lock === null) {
        if (Math.abs(t.x) > Math.abs(t.y) && Math.abs(t.x) > LOCK_PX) t.lock = 'x';
        else if (Math.abs(t.y) > Math.abs(t.x) && Math.abs(t.y) > LOCK_PX) t.lock = 'y';
      }

      if (t.lock === 'x') {
        // gesto horizontal: prevenimos scroll y arrastramos slides
        e.preventDefault(); // <- clave: solo si es horizontal
        const w  = el.clientWidth || 1;
        const dx = (t.x / w) * 100;
        this.applyDrag(dx);
      } else {
        // gesto vertical (o sin decidir): dejamos que el navegador haga scroll
        // no hacer preventDefault
      }
    };

    const onEnd = () => {
      if (!t.dragging) return;
      const w  = el.clientWidth || 1;
      const dx = (t.x / w) * 100;

      t.dragging = false;
      const threshPct = (SWIPE_PX * 100) / w;

      if (t.lock === 'x') {
        if (dx <= -threshPct) this.next();
        else if (dx >=  threshPct) this.prev();
        else this.snapBack();
        this.updateBarImmediate();
      }
      // si fue vertical, no hacemos nada especial
      t.lock = null;
    };

    el.addEventListener('touchstart', onStart, { passive: true  });
    el.addEventListener('touchmove',  onMove,  { passive: false }); // necesitamos poder llamar preventDefault solo en horizontal
    el.addEventListener('touchend',   onEnd,   { passive: true  });
    el.addEventListener('mousedown',  onStart);
    window.addEventListener('mousemove', onMove);
    window.addEventListener('mouseup',   onEnd);
  }


};


//======= MOBILE 
document.addEventListener('DOMContentLoaded', () => {
  const topbar = document.querySelector('.cfg-topbar');
  const summary = document.querySelector('.configurator-summary');
  const finalLine = document.querySelector('.cfg-final-line');
  if (!topbar || !summary || !finalLine) return;

  // Recordar posición original para restaurar en desktop
  const originalParent = topbar.parentNode;
  const originalNext = topbar.nextElementSibling;

  const mq = window.matchMedia('(max-width: 900px)');

  function placeForMobile(e){
    if (e.matches) {
      // Mover debajo del nombre del dress
      finalLine.insertAdjacentElement('afterend', topbar);
      topbar.style.margin = '6px 0 10px';
    } else {
      // Regresar a su lugar original
      if (originalNext && originalNext.parentNode === originalParent) {
        originalParent.insertBefore(topbar, originalNext);
      } else {
        originalParent.insertBefore(topbar, originalParent.firstChild);
      }
      topbar.style.margin = '';
    }
  }

  placeForMobile(mq);
  mq.addEventListener ? mq.addEventListener('change', placeForMobile)
                      : mq.addListener(placeForMobile);
});


//======= mobile tabs tops bottoms
document.addEventListener('DOMContentLoaded', () => {
  const mq = window.matchMedia('(max-width: 900px)');
  const tabs = Array.from(document.querySelectorAll('.cfg-mtab'));
  const groups = {
    '#group-tops': document.querySelector('#group-tops'),
    '#group-skirts': document.querySelector('#group-skirts')
  };

  if (!tabs.length || !groups['#group-tops'] || !groups['#group-skirts']) return;

  function showGroup(target){
    // Oculta ambos y marca la tab activa
    Object.values(groups).forEach(g => g.setAttribute('hidden', ''));
    tabs.forEach(btn => {
      const active = btn.dataset.target === target;
      btn.classList.toggle('is-active', active);
      btn.setAttribute('aria-selected', active ? 'true' : 'false');
    });
    groups[target].removeAttribute('hidden');
  }

  function enableMobileTabs(e){
    if (e.matches){// MOBILE
      // Asegura roles accesibles
      const tabsWrap = document.querySelector('.cfg-mobile-tabs');
      if (tabsWrap) tabsWrap.setAttribute('role','tablist');
      tabs.forEach(btn => { btn.setAttribute('role','tab'); });
      groups['#group-tops'].setAttribute('role','tabpanel');
      groups['#group-skirts'].setAttribute('role','tabpanel');

      // Estado inicial: TOPS activo (o respeta el último clic si existe)
      const current = tabs.find(b => b.classList.contains('is-active'))?.dataset.target || '#group-tops';
      showGroup(current);
    } else {// DESKTOP: mostrar ambos
      tabs.forEach(btn => {
        btn.classList.remove('is-active');
        btn.removeAttribute('aria-selected');
      });
      Object.values(groups).forEach(g => g.removeAttribute('hidden'));
    }
  }

  // Clicks en las tabs
  tabs.forEach(btn => {
    btn.addEventListener('click', (ev) => {
      const target = btn.dataset.target;
      if (window.matchMedia('(max-width: 900px)').matches) {
        showGroup(target);
      }
    });
  });

  // Ejecutar ahora y al cambiar el viewport
  enableMobileTabs(mq);
  mq.addEventListener ? mq.addEventListener('change', enableMobileTabs)
                      : mq.addListener(enableMobileTabs);
});

document.addEventListener('DOMContentLoaded', () => {
  const mq = window.matchMedia('(max-width: 900px)');

  const tabsBar   = document.querySelector('.cfg-mobile-tabs');
  const quizBar   = document.querySelector('.cfg-topbar');
  if (!tabsBar || !quizBar) return;

  // Guardar posición original para desktop
  const originalParent = tabsBar.parentNode;
  const originalNext   = tabsBar.nextElementSibling;

  function placeTabs(e){
    if (e.matches){
      // MOBILE: insertar tabs inmediatamente después del QUIZ
      quizBar.insertAdjacentElement('afterend', tabsBar);
      tabsBar.dataset.moved = 'true';
    } else {
      // DESKTOP: devolver tabs a su lugar original
      if (originalNext && originalNext.parentNode === originalParent) {
        originalParent.insertBefore(tabsBar, originalNext);
      } else {
        originalParent.appendChild(tabsBar);
      }
      delete tabsBar.dataset.moved;
    }
  }

  placeTabs(mq);
  mq.addEventListener ? mq.addEventListener('change', placeTabs)
                      : mq.addListener(placeTabs); // fallback
});

document.addEventListener('DOMContentLoaded', () => {
  const mq              = window.matchMedia('(max-width: 900px)');
  const quizBar         = document.querySelector('.cfg-topbar');
  const leftPanel       = document.querySelector('.configurator-left');
  const tabsBar         = document.querySelector('.cfg-mobile-tabs');
  const groupTops       = document.getElementById('group-tops');
  const groupSkirts     = document.getElementById('group-skirts');

  if (!quizBar || !leftPanel || !tabsBar || !groupTops || !groupSkirts) return;

  // Guardar posiciones originales (para desktop)
  const original = {
    tabsParent: tabsBar.parentNode,
    tabsNext:   tabsBar.nextElementSibling,
    topsParent: groupTops.parentNode,
    topsNext:   groupTops.nextElementSibling,
    skirtsParent: groupSkirts.parentNode,
    skirtsNext:   groupSkirts.nextElementSibling,
  };

  // Host que contendrá tabs + grupos en mobile
  let host = document.getElementById('cfg-mobile-host');

  function toMobile(){
    // crear host una sola vez
    if (!host) {
      host = document.createElement('div');
      host.id = 'cfg-mobile-host';
    }
    // insertar host debajo del QUIZ
    quizBar.insertAdjacentElement('afterend', host);
    // mover elementos
    host.appendChild(tabsBar);
    host.appendChild(groupTops);
    host.appendChild(groupSkirts);
  }

  function toDesktop(){
    // devolver tabs
    if (original.tabsNext && original.tabsNext.parentNode === original.tabsParent) {
      original.tabsParent.insertBefore(tabsBar, original.tabsNext);
    } else {
      original.tabsParent.appendChild(tabsBar);
    }
    // devolver grupos
    if (original.topsNext && original.topsNext.parentNode === original.topsParent) {
      original.topsParent.insertBefore(groupTops, original.topsNext);
    } else {
      original.topsParent.appendChild(groupTops);
    }
    if (original.skirtsNext && original.skirtsNext.parentNode === original.skirtsParent) {
      original.skirtsParent.insertBefore(groupSkirts, original.skirtsNext);
    } else {
      original.skirtsParent.appendChild(groupSkirts);
    }
    // limpiar host si quedó en el DOM
    if (host && host.parentNode) host.parentNode.removeChild(host);
  }

  function place(e){
    if (e.matches) toMobile(); else toDesktop();
  }

  place(mq);
  mq.addEventListener ? mq.addEventListener('change', place)
                      : mq.addListener(place);
});

//RESET
document.addEventListener('DOMContentLoaded', () => {
  const mq = window.matchMedia('(max-width: 900px)');
  const resetBtn = document.getElementById('cfg-clear-quiz');
  if (!resetBtn) return;

  // guarda su posición original para desktop
  const originalParent = resetBtn.parentNode;
  const originalNext   = resetBtn.nextElementSibling;

  function placeAfterHost(){
    const host = document.getElementById('cfg-mobile-host');
    if (!host) return;
    if (host.nextElementSibling !== resetBtn) {
      host.insertAdjacentElement('afterend', resetBtn);
    }
  }

  function handle(){
    if (mq.matches){
      placeAfterHost();
    } else {
      // restaurar en desktop
      if (originalNext && originalNext.parentNode === originalParent) {
        originalParent.insertBefore(resetBtn, originalNext);
      } else {
        originalParent.appendChild(resetBtn);
      }
    }
  }

  // reintenta cuando cambias de tab o el estado del quiz (por si el DOM se re-renderiza)
  document.querySelectorAll('.cfg-mtab').forEach(b=>{
    b.addEventListener('click', () => setTimeout(placeAfterHost, 0));
  });
  window.addEventListener('cfg:quiz-applied', placeAfterHost);
  window.addEventListener('cfg:quiz-cleared',  placeAfterHost);

  mq.addEventListener ? mq.addEventListener('change', handle) : mq.addListener(handle);
  handle();
});




//debug descarga un csv con todas las combinaciones existentes de sku
document.addEventListener('DOMContentLoaded', () => {

 /* ===== CFG: Exportador de SKUs finales (TopBase_BottomBase_TopFab_BottomFab) ===== */
  (function(){
    const SHOW_PARAM      = 'export_skus';      // ?export_skus=1
    const AVAILABLE_ONLY  = 'available_only';   // ?available_only=1
    const BTN_ID          = 'cfg-export-skus-btn';
    const FILENAME_PREFIX = 'final-skus';

    // ---------- helpers ----------
    function qsTrue(name){
      const v = new URLSearchParams(location.search).get(name);
      return v === '1' || v === 'true' || v === 'yes';
    }
    function todayStr(){
      const d = new Date(); const pad = n => String(n).padStart(2,'0');
      return `${d.getFullYear()}-${pad(d.getMonth()+1)}-${pad(d.getDate())}`;
    }
    function parseFinalSku(sku){
      const out = { final_sku: sku || '', top_base:'', bottom_base:'', top_fabric:'', bottom_fabric:'' };
      if(!sku || typeof sku !== 'string') return out;
      const p = sku.split('_');
      if(p.length >= 4){
        out.top_base = p[0]||''; out.bottom_base = p[1]||''; out.top_fabric = p[2]||''; out.bottom_fabric = p[3]||'';
      }
      return out;
    }
    function centsToMoney(any){
      if (any == null) return '';
      if (typeof any === 'number') return any >= 100 ? (any/100).toFixed(2) : any.toFixed(2);
      if (typeof any === 'string') return any.trim();
      if (typeof any === 'object' && any.amount != null) return String(any.amount);
      return '';
    }
    function makeCSV(rows){
      const headers = ['final_sku','top_base','bottom_base','top_fabric','bottom_fabric','product_handle','product_title','variant_id','variant_title','available','price'];
      const esc = s => {
        if (s==null) return '';
        const t = String(s);
        return /[",\n]/.test(t) ? `"${t.replace(/"/g,'""')}"` : t;
      };
      return [headers.join(','), ...rows.map(r=>headers.map(h=>esc(r[h])).join(','))].join('\n');
    }
    function download(filename, text){
      const blob = new Blob([text], {type:'text/csv;charset=utf-8;'});
      const url = URL.createObjectURL(blob);
      const a = document.createElement('a'); a.href = url; a.download = filename;
      document.body.appendChild(a); a.click(); setTimeout(()=>{URL.revokeObjectURL(url); a.remove();},0);
    }
    function injectButton(onClick){
      if(document.getElementById(BTN_ID)) return;
      const btn = document.createElement('button');
      btn.id = BTN_ID; btn.type='button'; btn.textContent='Descargar SKUs (CSV)';
      Object.assign(btn.style,{
        position:'fixed', right:'16px', bottom:'16px', zIndex:'99999', padding:'10px 14px',
        borderRadius:'10px', border:'1px solid #ccc', background:'#fff', boxShadow:'0 6px 20px rgba(0,0,0,.15)', cursor:'pointer'
      });
      btn.addEventListener('mouseenter',()=>btn.style.boxShadow='0 8px 26px rgba(0,0,0,.2)');
      btn.addEventListener('mouseleave',()=>btn.style.boxShadow='0 6px 20px rgba(0,0,0,.15)');
      btn.addEventListener('click', onClick);
      document.body.appendChild(btn);
    }

    function getFinalCollectionHandle(){
      const el = document.querySelector('#cfg-collection');
      if(!el) return null;
      try{
        const json = JSON.parse(el.textContent || el.innerText || '{}');
        return json && json.handle ? String(json.handle) : null;
      }catch(e){ return null; }
    }

    async function fetchCollectionProducts(handle){
      const out = [];
      let page = 1;
      const LIMIT = 250;
      for(;;){
        const url = `/collections/${encodeURIComponent(handle)}/products.json?limit=${LIMIT}&page=${page}`;
        const res = await fetch(url, {credentials:'same-origin'}).catch(()=>null);
        if(!res || !res.ok) break;
        const data = await res.json().catch(()=>null);
        const arr = data && Array.isArray(data.products) ? data.products : [];
        if(!arr.length) break;
        out.push(...arr);
        if(arr.length < LIMIT) break;
        page++;
        if(page>20) break;
      }
      if(!out.length){
        const alt = await fetch(`/collections/${encodeURIComponent(handle)}?view=json`, {credentials:'same-origin'}).catch(()=>null);
        if(alt && alt.ok){
          const data = await alt.json().catch(()=>null);
          if (data?.products?.edges) {
            return data.products.edges.map(e=>e.node);
          } else if (Array.isArray(data?.products)) {
            return data.products;
          } else if (Array.isArray(data?.items)) {
            return data.items;
          }
        }
      }
      return out;
    }

    function normalizeProductsShape(rawProducts){
      const out = [];
      const normalizeVariants = (v)=>{
        const list=[];
        if(Array.isArray(v)){
          for(const it of v){
            list.push({
              id: it.id ?? it.admin_graphql_api_id ?? '',
              title: it.title ?? '',
              sku: (it.sku ?? '').trim(),
              available: (it.available ?? it.availableForSale ?? it.in_stock ?? false),
              price: it.price ?? it.priceV2 ?? it.presentment_price ?? (it.presentment_prices?.[0]?.price?.amount)
            });
          }
          return list;
        }
        if(v && Array.isArray(v.edges)){
          for(const e of v.edges){
            const n = e?.node ?? {};
            list.push({
              id: n.id ?? n.admin_graphql_api_id ?? '',
              title: n.title ?? '',
              sku: (n.sku ?? '').trim(),
              available: (n.available ?? n.availableForSale ?? n.in_stock ?? false),
              price: n.price ?? n.priceV2 ?? n.presentment_price ?? (n.presentmentPrices?.edges?.[0]?.node?.price?.amount) ?? (n.presentment_prices?.[0]?.price?.amount)
            });
          }
          return list;
        }
        return list;
      };
      for(const p of rawProducts){
        const handle = p.handle ?? p.product_handle ?? '';
        const title  = p.title ?? p.product_title ?? p.name ?? '';
        const variantsRaw =
          (Array.isArray(p.variants) ? p.variants : null) ??
          (p.variants?.edges ? p.variants : null) ??
          (p.product?.variants?.edges ? p.product.variants : null) ??
          (Array.isArray(p.product?.variants) ? p.product.variants : null);
        out.push({ handle, title, variants: normalizeVariants(variantsRaw||[]) });
      }
      return out;
    }

    // ---------- construir filas del CSV ----------
    function buildRows(products, availableOnly){
      const seen = new Set();
      const rows = [];
      for(const p of products){
        for(const v of p.variants){
          const sku = (v.sku||'').trim();
          if(!sku) continue;
          if(availableOnly && !v.available) continue;

          const parsed = parseFinalSku(sku);
          const row = {
            final_sku: parsed.final_sku,
            top_base: parsed.top_base,
            bottom_base: parsed.bottom_base,
            top_fabric: parsed.top_fabric,
            bottom_fabric: parsed.bottom_fabric,
            product_handle: p.handle || '',
            product_title: p.title || '',
            variant_id: v.id || '',
            variant_title: v.title || '',
            available: v.available ? '1' : '0',
            price: centsToMoney(v.price)
          };
          const key = row.final_sku + '|' + row.variant_id;
          if(!seen.has(key)){ seen.add(key); rows.push(row); }
        }
      }
      return rows;
    }

    async function main(){
      if(!qsTrue(SHOW_PARAM)) return;

      const handle = getFinalCollectionHandle();
      if(!handle){
        // console.warn('[CFG Export] Falta <script id="cfg-collection">{ "handle": "..." }</script> en el Liquid.');
        return;
      }

      const raw = await fetchCollectionProducts(handle);
      const products = normalizeProductsShape(raw);
      const availableOnly = qsTrue(AVAILABLE_ONLY);

      injectButton(() => {
        const rows = buildRows(products, availableOnly);
        const csv  = makeCSV(rows);
        const suffix = availableOnly ? '-available' : '';
        download(`${FILENAME_PREFIX}${suffix}-${todayStr()}.csv`, csv);
      });
    }

    if(document.readyState==='loading'){ document.addEventListener('DOMContentLoaded', main); }
    else { main(); }
  })();

  // === FORCE LOAD TRYON SCRIPT IF NOT LOADED ===
  (function loadTryOnScript() {
    if (window.TryOn) return; // ya cargado

    const script = document.createElement('script');
    script.src = 'https://cdn.tryon.tech/tryon.js';
    script.async = true;
    script.onload = function () {
      console.log('✅ TryOn script loaded manually');
      if (typeof window.TryOn?.attachButtons === 'function') {
        window.TryOn.attachButtons();
      }
    };
    script.onerror = function () {
      console.error('❌ Failed to load TryOn script.');
    };
    document.head.appendChild(script);
  })();

})();